import { Component, OnInit, ViewChild } from '@angular/core';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { ToastrService } from 'ngx-toastr';
import { EncdecService } from 'src/app/services/encdec.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
// import { element } from '@angular/core/src/render3';
import { stat } from 'fs';
import { RemoveRecordPopupComponent } from '../remove-record-popup/remove-record-popup.component';
import { min } from 'rxjs/operators';
// import { moment } from 'ngx-bootstrap/chronos/test/chain';
// import { theme } from 'highcharts';
// import { timeStamp } from 'console';

import { TranslateService } from '@ngx-translate/core';
import { RemovefilePopupComponent } from 'src/app/common/ngbmodel/removefile-popup/removefile-popup.component';
import { ThrowStmt } from '@angular/compiler';
import { objectEach } from 'highcharts';
import { count } from 'console';
import { DATE } from 'ngx-bootstrap/chronos/units/constants';
import {themedataObj,indicatorlist,subindlist} from 'src/assets/i18n/en.json'
import { element } from 'protractor';
import { copyStyles } from '@angular/animations/browser/src/util';
import { nullSafeIsEquivalent } from '@angular/compiler/src/output/output_ast';
import { forEach } from '@angular/router/src/utils/collection';


@Component({
  selector: 'app-forminput',
  templateUrl: './forminput.component.html',
  styleUrls: ['./forminput.component.css']
})
export class ForminputComponent implements OnInit {
  @ViewChild('alertModal',{})alertModal;

  valuePresent:boolean;
  theme = {};
  validation: object = { year: true, month: true };
  myObserver;
  userdetails = {};
  userlocationtype = null;
  businessdata = [];
  startDate: Date;
  modalRef: any;
  showdistdropdown: boolean;
  districtflag: boolean;
  currentyr;
  prevyr;
  heirarchydata;
  meetingflag: boolean = true;
  indicatorflag: boolean = true;
  indicatorData;
  disablebuttons: Boolean;
  viewForm: Boolean;
  activeSpinner: Boolean;
  addingtabledata = 1;
  rawdata;
  fileUUIDList: any = []
  disableedit: boolean = false;
  fileIndicatorList = [];
  currentIndicatorUuid = { parent: null, child: null };
  subIndicatorList = [{ nln: '', fd: '', rtfall: '', sin: null, fileUUID: '', serialNo: '' }];
  smallRiverList = [{ srn: '', nactrjv: '', ptrp: null, rau: '', losrr: '', fileUUID: '', serialNo: '' }];
  wetLandList = [{ wlnl: '', wlsz: '', atfwlc: null, fileUUID: '', serialNo: '' }];
  springBisunessDataList = [{ sprn: '', atfrs: '', scors: null, fileUUID: '', serialNo: '' }];
  stpyesdatalist = [{ stpn: '', nact: '', dprp: '', pa: '', ut: '', urn: '', uom: '', fileUUID: '', serialNo: '' }];
  grossDataList = [{ indn: '', sect: '', etpp: null, dcw: null, fileUUID: '', serialNo: '' }];
  industryDataList = [{ indn: '', nact: null, epani: null, ihbc: null, indclsr: null, fileUUID: '', serialNo: '' }];
  nallaDataList = [{ nln: '', td: null, cubrn: null, fileUUID: '', serialNo: '' }];
  stpdataformat = [{ stpn: '', stpc: '', custpc: '', mds: null, dcgmc: null, pcstpu: '', fileUUID: 'null', serialNo: 'null' }];
  stpdatavalueformat = [{ stpn: '', stpc: '', custpc: '', mds: null, dcgmc: null, pcstpu: '', fileUUID: 'null', serialNo: 'null' }];
  stpDataList = [{ stpn: '', stpc: '', custpc: '', mds: null, dcgmc: null, pcstpu: '', fileUUID: '', serialNo: '' }];
  stpBooleanDataList = [{ stpn: '', nact: '', dprp: '', pa: '', ut: '', urn: '', uom: '', fileUUID: 'null', serialNo: 'null' }];
  stpBooleanDatalist = [{ stpn: '', nact: '', dprp: '', pa: '', ut: '', urn: '', uom: '', fileUUID: 'null', serialNo: 'null' }];
  stpPercentageDataList = [{ stpn: '', flfc: '', asic: '', fileUUID: '', serialNo: '' }];
  waterReusedDataList = [{ stpn: '', custpc: '', tr: '', cmrcl: '', cnsrn: '', agcl: '', grdng: '', onp: '', fileUUID: '', serialNo: '' }];
  planDataList = [{ stpn: '', stpc: '' }];
  dateformat = { value: 'yyyyMMdd' }
  monthmapping = ['June', 'July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March', 'April', 'May'];
  monthList: any = [
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
  ];
  windowdata: any;
  fieldDropDownList: object = { AssesmentList: {}, StateList: [], DistrictList: [], AssesmentListDistrict: [] };
  exceluploadData: object = { 'excelFile': null };
  uploadMeetingDataObj: object = { 'file': null, 'photo': null };
  multiplefileUpload: object = { 'file': null };
  multipleimgUpload: object = { 'photo': null }
  indicatoruploadData: object = { 'chooseFile': null }
  formInputfilter: object = { 'ay': "", 'lu': "", 'datasubmit': 'statewise', 'distuuid': '', 'montharray': '' }
  // validation: boolean[] = new Array(1).fill(true);
  Validation: boolean[] = new Array(1).fill(true);
  outputerror: string;
  selectedFiles = {};
  numden: any;
  isNumBig: boolean = false;
  state_nodal_officer: string;
  dist_nodal_officer: string;
  selectedrow: any;

  colorData = {};
  imageFiles: object = { 'photo': null }
  themeList: any = [];
  fetchData: any;
  viewform: boolean;
  indicatorsList: any = [];
  fetchIndicatorList: any = [];
  activeSubIndicators: any = [];
  indicatorThemes: any;
  monthsList = [];
  assesmentyear: any;
  selectedMonth: any;
  indicatorLabel: any;
  childList: any[];
  currentId: any;
  indicatordata: any;
  wetlandData: boolean;
  springRejuvendData: any;
  GrossData: any;
  sectorList: { "tannery": string; "textile": string; "paper": string; "metal": string; "oil": string; "food": string; "others": string };
  selectedSector: any;
  industryData: any;
  nallaData: any;
  stpData: any;
  stpPercentageData: any;
  reusageWaterData: any;
  fileuploadData: any;
  fileuuid: any = []
  stpDatavalue: any;
  stpboolean: any;
  fileList = {};
  fileIDList=[];
  // fileNameList=[];
  fileData=[];
  indicatorhierarchyData: any = [];
  selectedCharacter: any = [];
  subindicatorData: any = [];
  valueList: any;
  curentLabel: boolean;
  yesclickValue: any;
  nallaname: any;
  flowdaily: any;
  riverdata: any;
  screeninstall: any;
  hardcodedBusinessData: any = [];
  dynamicflag: any;
  mediaLabels: any;
  nallaDataObject: any = [];
  smallRiverObject: any = [];
  wetLandTableData: any = [];
  springTableData: any = [];
  grosstableData: any = [];
  industryTabledata: any = [];
  nalladataObject: any = [];
  stpdataObject: any = [];
  stpbooleanDataObj: any = [];
  stppercentData: any = [];
  reusagetableData: any = [];
  dynamiclabel: any;
  solidwaste: any;
  ghatslabel: any;
  percentagelabel: boolean;
  afferostationlabel: boolean;
  gangagramlabel: boolean;
  engagedlabel: boolean;
  pondslabel: boolean;
  migratorylabel: boolean;
  gangalabel: any;
  educatinglabel: boolean;
  igolabel: boolean;
  ulblabel: boolean;
  inspectionlabel: boolean;
  authoritylabel: boolean;
  riverbanklabel: boolean;
  solidwastehotspot: any;
  adequatelabel: boolean;
  wastedumplabel: boolean;
  devlabel: boolean;
  soilconvlabel: boolean;
  stablisedlabel: boolean;
  gannurlabel: boolean;
  medicinelabel: boolean;
  capacitylabel: boolean;
  stpmanage: boolean;
  fecalsludge: boolean;
  planlabel: boolean;
  regularmeetinglabel: boolean;
  dgclabel: boolean;
  villagepop: boolean;
  gangaaarti: boolean;
  swachsurukshen: boolean;
  statuslabel: boolean;
  gangaapp: any;
  biodiversity: boolean;
  awarenesss: boolean;
  gangasafety: boolean;
  yearlylabel: boolean;
  masterlabel: boolean;
  rivercentric: boolean;
  budgetaccounts: boolean;
  selecteditemobj: any;
  meetingsDGC: boolean;
  vacancyaccounts: boolean;
  bhuvanapp: boolean;
  plasticwastehotspot: boolean;
  status: {};
  indicatorremove: any;
  selectedindicator: any;
  stpDatavalue2: any;
  indicatorvalue: boolean;
  yearDropDownList: any;
  childsdata: any;
  indicatorselectedFile: any = {};
  filelistid: any = [];
  toggle_menu: boolean = true;

  selectedFile: any = [];
  fileId: string = ""
  currentindlist: any;
  currentvalue: any;
  showbuttons: boolean;
  meetingdateobj: any;
  attendanceFilter: object = { mom: '', startdate: '' };

  dropdownSettings: any = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    noDataAvailablePlaceholderText: 'No locations available.',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  officialsList: any

  SelectFilter: any = {
    'meeting': []
  }

  SelectMinutesFilter: any = {
    'meeting': []
  }
  customFilter: any = {
    'year': '',
    'cat': []
  }
  meetingDataList: any = [
    { "item_id": "publicawareness", "item_text": "Public Awareness" },
    { "item_id": "wetlandsconversation", "item_text": "Wetlands Conservation/Stream Rejuvenation" },
    { "item_id": "pre-plantationactivities", "item_text": "Pre-plantation activities" },
    { "item_id": "ghatsandcrematoria", "item_text": "Ghats and Crematoria" },
    { "item_id": "naturalfarming", "item_text": "Natural Farming" },
    // { "item_id":"tourism","item_text":"Tourism"},
    { "item_id": "arthganga", "item_text": "Arth Ganga" },
    { "item_id": "biodiversityconservation", "item_text": "Biodiversity Conservation" },
    { "item_id": "wastewaterandsludgereuse", "item_text": "Waste Water and Sludge Reuse" },
    { "item_id": "culturalheritageandtourism", "item_text": "Cultural Heritage and Tourism" },
    { "item_id": "plantationactivities", "item_text": "Plantation Activities" },
    { "item_id": "meetingnotheld", "item_text": "Meeting not held"},
    { "item_id": "others", "item_text": "Others" },
  ]

  meetingMintutes: any = [
    { "item_id": "fourweekendSabhaandCleanGangaeducationdriveswereconductedacrossthedistrictwhichhelpedinincreasingawarenessoftheNMCGmission", "item_text": "Four weekend Sabha and Clean Ganga education drives were conducted across the district which helped in increasing awareness of the NMCG mission" },
    { "item_id": "conductofplantationcompetitionsGangarunsoneitherdayconcludingwithworshipofthedivinemotherGangaeverynight.", "item_text": "Conduct of plantation competitions, Ganga runs on either day concluding with worship of the divine mother Ganga every night." },
    { "item_id": "SocialMediaawarenessaboutNMCGwasmadebyplatformslikeFacebook,Twitter,andYouTubebyconstitutingaseparatesocialmediaexpertteam", "item_text": "Social Media awareness about NMCG was made by platforms like Facebook, Twitter, and YouTube by constituting a separate social media expert team" },
    { "item_id": "finalizationoftheBudgetmadefor10Nallastobemonitoredincludingcapturingofwastegeneratedthroughsensors", "item_text": "Finalization of the Budget made for 10 Nallas to be monitored including capturing of waste generated through sensors," },
    { "item_id": "constitutionofateamforefficientlycarryingouttheinstallationofwastetreatmentplants", "item_text": "Constitution of a team for efficiently carrying out the installation of waste treatment plants" },
    { "item_id": "presentationoftheReportofthewastegenerationandtreatmentactivityundertakenineachof(number)ULBsofthedistrict", "item_text": " Presentation of the Report of the waste generation and treatment activity undertaken in each of (number) ULBs of the district." },
    { "item_id": "rankingULBsontheindicatorslikefrequencyofCleaning,disposalandrecyclingactivitiescarriedout", "item_text": "Ranking ULBs on the indicators like frequency of Cleaning, disposal and recycling activities carried out" },
    { "item_id": "numberofwastehotspots,opendumpsitessuccessfullyidentifiedacrossallULBswithinthedistrict ", "item_text": "Number of waste hotspots, open dumpsites successfully identified across all ULBs within the district." },
    { "item_id": "discussiononthecurrentsituationofdevelopmentandmaintenanceof(Number)Ghats", "item_text": "Discussion on the current situation of development and maintenance of (Number) Ghats" },
    { "item_id": "reportontheamountofsiltremovedformGhatsandeffectsontheproductivityoffarmswhereutilizedandthegroundwaterlevelincrease", "item_text": "Report on the amount of silt removed form Ghats and effects on the productivity of farms where utilized and the groundwater level increase" },
    { "item_id": "assessmentofthepreviouslyconstructedelectriccrematorium", "item_text": "Assessment of the previously constructed electric crematorium" },
    { "item_id": "budgetingofthe(number)newcrematoriumtobemadeorrenovationrequired", "item_text": "Budgeting of the (number) new crematorium to be made or renovation required" },
    { "item_id": "reportonthefundsflowinthe(Number)Afforestationandsoilconservationactivitiesconductedinriverbankareas", "item_text": "Report on the funds flow in the (Number) Afforestation and soil conservation activities conducted in riverbank areas" },
    { "item_id": "measurementofreductionincarbonfootprintandincreaseinRiverbankstabilizationbyanexpert", "item_text": "Measurement of reduction in carbon footprint and increase in Riverbank stabilization by an expert." },
    { "item_id": "discussionontheawarenessactivitiesconductedacrossGangariverbanksforincreasingafforestation", "item_text": "Discussion on the awareness activities conducted across Ganga riverbanks for increasing afforestation" },
    { "item_id": "detailsoftheriverbankarealandscape", "item_text": "Details of the riverbank area landscape" },
    { "item_id": "reportslaidtoassessthesituationandconditionof(Number)OldSeweragetreatmentPlants(STP)and(Number)EffluentTreatmentPlants(ETPs)", "item_text": "Reports laid to assess the situation and condition of (Number) Old Sewerage treatment Plants (STP) and (Number) Effluent Treatment Plants (ETPs)" },
    { "item_id": "listandtrendsinquantityofindustrialeffluentsgeneratedvis-à-vislastfiguresacrossallULBs", "item_text": "List and trends in quantity of industrial effluents generated vis-à-vis last figures across all ULBs" },
    { "item_id": "stepstakentorehabilitatenon-functionalSewerageTreatmentPlantsincludingdetailsofnumberofDPRpreparedandprojectapproved", "item_text": "Steps taken to rehabilitate non-functional Sewerage Treatment Plants including details of number of DPR prepared and project approved" },
    { "item_id": "functionaland(Number)under-constructionSTPsincludingdetailsofcapacityutilizationofPlants", "item_text": "(Number) functional and (Number) under-construction STPs including details of capacity utilization of Plants" },
    { "item_id": "anymaterialdiscrepancyfoundunder(Number)Inspectionand(Number)surprisevisitsconductedstatingdetailsthereof", "item_text": "Any material discrepancy found under (Number) Inspection and (Number) surprise visits conducted stating details thereof" },
    { "item_id": "discussionofthedatacapturedinGangaMonitoringcenters", "item_text": "Discussion of the data captured in Ganga Monitoring centers." },
    { "item_id": "A3R(Recycle,Reuse,andreduce)Teamdiscusseddetailsofreuseoftreatedwastewaterandindustrialwasteinvariouspurposes", "item_text": "A 3R (Recycle, Reuse, and reduce) Team discussed details of reuse of treated wastewater and industrial waste in various purposes" },
    { "item_id": "acommitteewasformedforauditingthedetailsofactionstakeninformofpunishmentandpenaltiesonnon-compliantindustries", "item_text": "A committee was formed for auditing the details of actions taken in form of punishment and penalties on non-compliant industries" },
    { "item_id": "formingofcommitteeincludinghandingtorectifytheharmcausedtoGangabytakingseveraldisciplinaryactions", "item_text": "Forming of committee including handing to rectify the harm caused to Ganga by taking several disciplinary actions." },
    { "item_id": "discussiononthesuccessofGangaGramYojanaandnumberoftoiletsconstructedacrossGangaGrams", "item_text": "Discussion on the success of Ganga Gram Yojana and number of toilets constructed across Ganga Grams" },
    { "item_id": "reportbysocialmediateamworkingtowardssuccessofJanGangaAppandBhuvanGangaApp", "item_text": "Report by social media team working towards success of Jan Ganga App and Bhuvan Ganga App" },
    { "item_id": "discussionontheresultsGangaGramSwachhSurvekshanandactionstaken", "item_text": "Discussion on the results Ganga Gram Swachh Survekshan and actions taken" },
    { "item_id": "disciplinarycommitteereportontheGangaPraharisandGangaMitra/Volunteers", "item_text": "Disciplinary committee report on the Ganga Praharis and Ganga Mitra/ Volunteers" },
    { "item_id": "reportonactivitiesdoneforpreservationofbiodiversity", "item_text": "Report on activities done for preservation of biodiversity" },
    { "item_id": "detailsofbiodiversityspottedacrossallULBswhichincludesdetailsofendangeredspecies,fisheries,andMigratoryBirds", "item_text": "Details of biodiversity spotted across all ULBs which includes details of endangered species, fisheries, and Migratory Birds." },
    { "item_id": "detailsoftheawarenesscampaignrunineachULBsforbiodiversitypreservationawarenessbuilding", "item_text": "Details of the awareness campaign run in each ULBs for biodiversity preservation awareness building" },
    { "item_id": "verificationofreportfromMinistryofJalShaktionnumberofDGCmeetingsheldineverymonthincludingrollcalldetails", "item_text": "Verification of report from Ministry of Jal Shakti on number of DGC meetings held in every month including roll call details" },
    { "item_id": "actionstakenindirectionofGangaSafetyauditsandSandminingplansunderMasterplanforULBswherepopulationismorethan10Lakhs", "item_text": "Actions taken in direction of Ganga Safety audits and Sand mining plans under Master plan for ULBs where population is more than 10 Lakhs" },
    { "item_id": "detailsofActivitiesgoingonthethemeofConservationandRejuvenationofSmallRiverandWetlands", "item_text": "Details of Activities going on the theme of Conservation and Rejuvenation of Small River and Wetlands" },
    { "item_id": "Resultsofthesurveyconductedforgettingnewideasonrejuvenationactivities", "item_text": "Results of the survey conducted for getting new ideas on rejuvenation activities" },


  ]


  // attendancetableData :any = [
  //   {officials : "District Collector(Chairperson)",post:"Chairperson",name:"",contactno:"",emailid:"",attendance :''},
  //   {officials : "Representative from municipalities",post:"Member",name:"",contactno:"",emailid:"",attendance :''},
  //   {officials : "Representative from gram panchayats",post:"Member",name:"",contactno:"",emailid:"",attendance :''},
  //   {officials : "Representative from Public Works",post:"Member- ex-officio",name:"",contactno:"",emailid:"",attendance :''},
  //   {officials : "Representative from Irrigation",post:"Member- ex-officio",name:"",contactno:"",emailid:"",attendance :''},
  //   {officials : "Representative from Public Health Engineering",post:"Member- ex-officio",name:"",contactno:"",emailid:"",attendance :''},
  //   {officials : "Representative from Rural Drinking Water Department",post:"Member- ex-officio",name:"",contactno:"",emailid:"",attendance :''},
  //   {officials : "Representative from State Pollution Control Board",post:"Member- ex-officio",name:"",contactno:"",emailid:"",attendance :''},
  //   {officials : "Environmentalists associated with River Ganga protection",post:"Member",name:"",contactno:"",emailid:"",attendance :''},
  //   {officials : "Environmentalists associated with River Ganga protection",post:"Member",name:"",contactno:"",emailid:"",attendance :''},
  //   {officials : "Representative of local industry	",post:"Member",name:"",contactno:"",emailid:"",attendance :''},
  //   {officials : "Divisional Forest Officer(Convenor)",post:"Member Convenor",name:"",contactno:"",emailid:"",attendance :''},
  // ]
  genderList: any;
  showthemeData: boolean;
  themeflag: any[];
  indicatorList = [];
  meetingSendData: any;
  meetingModuleList = [{ officials: '', name: '', post: '', contactno: '', emailid: '', attendance: null, gender: null }]
  attendanceList: any;
  attendancetableList: any[];
  metaDatalist: any[];
  userdetail: object = {};
  tableData = {};
  loginUserStatus: boolean;
  showtabledata: boolean;
  rawTableData: any[];
  attendanceTableRawData: any = [
    { officials: "District Collector", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from municipalities", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from gram panchayats", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from Public Works", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from Irrigation", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from Public Health Engineering", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from Rural Drinking Water Department", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from State Pollution Control Board", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "District official to be nominated by DC", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Divisional Forest Officer", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Environmentalists associated with River Ganga protection", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative of local industry", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    // { officials: "", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    // { officials: "", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    // { officials: "", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    // { officials: "", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    // { officials: "", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    // { officials: "", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    // { officials: "", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    // { officials: "", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
  ];
  rawdataList: any;
  meetingdataArray: any[];
  selectedItem = [];
  showtextBox: boolean;
  meetingfilesData: any;
  filename: string = "";
  imagename: string = ""
  tabledataFormat: any[];
  selectedDate: any;
  showfile: boolean;
  @ViewChild('dataSubmissionModal',{})dataSubmissionModal;
  fileselected: boolean;
  fileselect: boolean;
  buttondisable: boolean;
  multiplefileName: string = ""
  showimageoption: boolean;
  imagedisable: boolean;
  multipleimageName: string = ""
  wrongFileCheck: boolean = false;
  wrongimgflag: boolean = false;
  itemselected: boolean = false;
  dateSelected: boolean = false;
  dynamicindLabel: boolean;
  ngoLabel: boolean;
  cremtorialLabel: boolean;
  emailvalid: boolean = true;
  dataSubmittedFlag: boolean=false;
  dateDate = new Date();
  year = this.dateDate.getFullYear();
  month = this.dateDate.getMonth();
  day = this.dateDate.getDay();
  showinputButton: boolean =true;
  dateObj: Date;
  minDate: { year: number; month: number; day: number; };
  maxDate: { year: number; month: number; day: number; };
  prevbutton: boolean;
  nextbutton: boolean;
  enabledThemes:any[];
  imageselect: boolean;
  submitStatus: boolean;
  momentered: boolean;
  modalReference: any;
  // showIndicatorData: boolean = false;


  constructor(private submitdataSerivce: SubmitdataService,
    public utils: UtilsModule, private modalService: NgbModal,
    private constants: ConstantsModule,
    private logsrv: AuthloginService,
    private toastr: ToastrService,
    private router: Router,
    private encdecservice: EncdecService,
    private translate: TranslateService,
    private route: ActivatedRoute,) {
    translate.setDefaultLang('en');
    this.myObserver = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
      }

      if (event instanceof NavigationEnd) {

        this.initializeOnStateLoad(event);
      }

      if (event instanceof NavigationError) {
      }
    });
  }

  ngOnDestroy() {
    this.myObserver.unsubscribe();    
  }


  ngOnInit() {
    this.submitdataSerivce.getStatusOfToken();
    this.fetchAssesmentYear();
    this.setMonthCurrentDefault();
    this.initializeOnStateLoad(null);
    this.currentindlist = this.constants.CURRENT_NEXT_MAPPING;
    // console.log(this.attendancetableData);
    //  this.getColourdata();
    this.officialsList = this.constants.OFFICIALS_LIST;
    this.genderList = this.constants.GENDER_LIST;
    this.attendanceList = this.constants.ATTENDANCE_LIST;
    this.state_nodal_officer = this.constants.USER_TYPES["STATE_NODAL_OFFICER"];
    this.dist_nodal_officer = this.constants.USER_TYPES['DISTRICT_NODAL_OFFICER'];
    this.monthsList = this.monthList;
    this.assesmentyear = this.formInputfilter['ay'];
    this.sectorList = this.submitdataSerivce.SECTOR_LIST;
    this.statusFix();
    this.statusFixForRiverdata();
    this.statusFixforspringList();
    this.setCurrentMonthFullName();

    let jsondata = [{"id":"92358172-760d-41e5-be9e-03d32d1f037b","value":"yes"},
    {"id":"b8f79583-f7d1-47f5-9717-4f52f83ab877","value":"yes"},
    {"id":"e8d6f3ec-b94e-45da-95d6-7fffeb82dcb2","value":"yes"},
    {"id":"731c876c-d8bd-449b-81c8-527f402e412d","value":"yes"}];
    // this.enabledThemes = jsondata;
    // console.log("enabledthemes",this.enabledThemes);    

  }
  async getWindowStatus() {
    let options = {
      "childlist": [this.formInputfilter['lu']],
      "yearlist": this.submitdataSerivce.getassesmentYear(),
      "view": this.constants.VIEWS['admin'],
      "cType": this.constants.LOCATION_CONSTANT['STATE']
    }
    this.windowdata = await this.submitdataSerivce.getWindowStatus(options);
  }
  // selectOption(month){
  //   this.formInputfilter['montharray'] = month;
  // }
  itemAndDateSelected(email){
    if(this.dateSelected && this.itemselected){
      // if(this.emailvalid){
        return true;
      // }
    }
    else{
      return false;
    }
  }

  addMeetingModuleData() {
    this.meetingModuleList.push({ officials: '', name: '', post: '', contactno: '', emailid: '', attendance: null, gender: null })
  }

  removeMeetingModuleData(index) {
    this.meetingModuleList.splice(index, 1)
  }
  fetchAssesmentYear(){
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    })
    this.formInputfilter['ay'] = dropDownYear;
  }
  setCurrentMonthFullName() {
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj => {
      if (parseInt(monthObj['key']) == currentmonth + 1) {
        currentmonthObj = monthObj;
      }
    });
    this.formInputfilter['montharray'] = currentmonthObj['key'];
  }
  sectorChange(sector) {
    this.selectedSector = sector;
  }

  onItemSelect() {

  }

  onSelectAll() {

  }

  onItemDeSelect() {

  }
  onItemDeSelectAll() {

  }

  getColourdata() {
    let postdata = {};
    postdata["cType"] = this.state_nodal_officer == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['STATE'] : this.constants.LOCATION_CONSTANT['DISTRICT']
    postdata["ay"] = this.formInputfilter['ay'];
    postdata["lu"] = this.dist_nodal_officer ? this.userdetails['loggedUserData']['userProfile']['locationId'] : this.userdetails['loggedUserData']['userProfile']['stateUUID'];
    this.submitdataSerivce.getcolourThemeData(postdata).subscribe(data => {
      this.colorData = data

    });

  }
  initializeOnStateLoad(year) {
    this.userdetails = this.logsrv.checkloginstatus();
    this.userdetail['login'] = this.encdecservice.rsadec(this.constants.PRIVATE_KEY, this.userdetails['login']);
    this.loginUserStatus = (this.userdetail['login'] == "jh_dumka" || this.userdetail['login'] == "jh_garhwa" || this.userdetail['login'] == "jh_giridih" || this.userdetail['login'] == "jh_godda" || this.userdetail['login'] == "jh_gumla") ? true : false;
    this.userlocationtype = this.userdetails['loggedUserData']['userProfile']['locationType']
    this.formInputfilter['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'];
    // console.log("ouoi",this.userdetails);
    
    // this.getWindowStatus();
    // this.yearDropDownList = this.submitdataSerivce.getassesmentYear();
    // this.formInputfilter['ay'] = this.yearDropDownList[this.yearDropDownList.length - 1];
    // this.getAssesmentYear(year);
    // this. getAssesmentYears(year)
    // if (this.formInputfilter['ay']) {
    //   this.getcurrentBusinessData();
    // }
    // this.fetchIndicators();
    // this.getcurrentBusinessData();
    // this.getassesmentunit();
  }
  setMonthCurrentDefault() {
    let dateInput = this.formInputfilter['ay'];
    dateInput = dateInput.split('-');
    let d = new Date();
    this.minDate = { year: Number(dateInput[0]), month: d.getMonth() + 1, day: 1 };
    this.dateObj = new Date();
    this.maxDate = { year: this.dateObj.getFullYear(), month: this.dateObj.getMonth() + 1, day: this.dateObj.getDate() }
  }
  activeTheme(label) {
    for (let value of this.heirarchydata) {
      if (value.label == label) {
        value['class'] = "active";
      } else {
        value['class'] = ''
      }
    }
  }
  addSubIndTextBox() {
    if (this.preValidation()) {
      this.subIndicatorList.push({ nln: '', fd: '', rtfall: '', sin: '', fileUUID: '', serialNo: '' });
    } else {
      this.toastr.error("Fill out the required fields  before adding new record");
    }
    // this.getdynamicIndicators();
  }
  keyPressAlphanumeric(event) {

    let inputdata = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9]/.test(inputdata)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  datepickermodel(value) {
    this.attendanceFilter['startdate'] = this.formatDate(value);
  }
  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('');
  }
  datepickermodelforstart(value) {
    this.attendanceFilter['startdate'] = this.getDateFormat(value);
  }
  getDateFormat(date) {
    let year = date.year;
    let month = date.month;
    let day = date.day;
    if (parseInt(month) < 10) {
      month = "0" + month.toString();
    }

    if (day < 10) {
      day = "0" + day.toString();
    }
    return year.toString() + month + day;
  }
  removeSubIndTextBox() {
    this.subIndicatorList.pop();
  }
  inputTypeSelect(e, i) {
    this.subIndicatorList[i]['sin'] = e.target.value;
  }
  addsmallriverstextBox() {
    if (this.mandatoryChecks()) {
      this.smallRiverList.push({ srn: '', nactrjv: '', ptrp: null, rau: '', losrr: '', fileUUID: '', serialNo: '' })
    } else {
      this.toastr.error("Fill out the required fields  before adding new record");
    }
  }
  removesmallRiverBox(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.smallRiverList.splice(index, 1);
      }
    })
  }
  removedataformat(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.stpdataformat.splice(index, 1);
      }
    })
  }
  addplanData(){
    if(this.validatePlanlabel()){
      this.planDataList.push({ stpn: '', stpc: '' })
    } else{
      this.toastr.error("Fill out the required fields  before adding new record");
    }
  }
  removeplanData(index){
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.planDataList.splice(index, 1);
      }
    })
  }

  addStpDatayes() {
    //this.stpyesdatalist.push({ stpn: '', nact: '', dprp: '', pa: '', ut: '', urn: '', uom: '', fileUUID: '', serialNo: '' });
    this.stpBooleanDatalist.push({ stpn: '', nact: '', dprp: '', pa: '', ut: '', urn: '', uom: '', fileUUID: '', serialNo: '' });
  }
  removeStpyesformat(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        //this.stpyesdatalist.splice(index, 1);
        this.stpBooleanDatalist.splice(index,1);
      }
    })
  }
  addstpvalueformat() {
    this.stpdatavalueformat.push({ stpn: '', stpc: '', custpc: '', mds: null, dcgmc: null, pcstpu: '', fileUUID: '', serialNo: '' })
  }
  removestpvalue(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.stpdatavalueformat.splice(index, 1);
      }
    })
  }
  addstpdataformat() {
    this.stpdataformat.push({ stpn: '', stpc: '', custpc: '', mds: null, dcgmc: null, pcstpu: '', fileUUID: 'null', serialNo: 'null' });
  }
  inputtypeSelects(e, i) {
    this.smallRiverList[i]['ptrp'] = e.target.value;
  }
  inputtypeSelect(e, i) {
    this.smallRiverList[i]['rau'] = e.target.value;
  }
  addwetlandtextBox() {
    if (this.mandatoryChecksforwetland()) {
      this.wetLandList.push({ wlnl: '', wlsz: '', atfwlc: null, fileUUID: '', serialNo: '' })
    } else {
      this.toastr.error("Fill out the required fields  before adding new record");
    }
  }
  inputTypeStp(e, i) {
    this.stpDataList[i]['mds'] = e.target.value;
  }
  inputTypedata(e, i) {
    this.stpDataList[i]['dcgmc'] = e.target.value;
  }
  removewetlandTextBox(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.wetLandList.splice(index, 1);
      }
    })
  }
  getnextloginBased() {
    let nextinduuid = this.currentindlist[this.currentId];
    this.fetchData.forEach(element => {
      element['childList'].forEach(indlist => {
        if (indlist['entityUUID'] == nextinduuid) {
          this.fetchSubIndicator(indlist);
        }
      });
    });    
  }
  getnextIndicators() {
    let nextinduuid = this.currentindlist[this.currentId];
    this.fetchData.forEach(element => {
      if (element['label'] == "Public Awareness") {
        element['childList'].forEach(indlist => {
          if (indlist['entityUUID'] == nextinduuid) {
            this.fetchSubIndicator(indlist);
          }
        });
      }
    });
  }
  meetingValueChange(table) {
    table['valuechanged'] = true;
  }
  getuploadedRawData() {
    this.rawTableData = [];
    let rawdata = {
      "lu": this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'],
      "ay": this.formInputfilter['ay'],
      "subTp": this.formInputfilter['montharray'],
      "view": this.constants.VIEWS['admin'],
      "cType": this.constants.LOCATION_CONSTANT['DISTRICT'],
      "userType": this.userdetails['roles'][0]
    }
    this.submitdataSerivce.getrawdata(rawdata).subscribe(metadata => {
      this.getnewdataFormat(metadata);
      this.formatminutesData(metadata);
      this.fileFetchDetails(metadata);      
      let rawdata = {};
      rawdata = metadata['meetings'];
        this.rawdataList = metadata['meetings'];
      if (Object.keys(rawdata).length === 0) {
        this.showtabledata = false;
      } else {
        this.showtabledata = true;
      }

    });
  }
  fileFetchDetails(metadata: any) {
    let attendanceMeetings = {};
    attendanceMeetings = metadata['meetings'];
    if (Object.keys(attendanceMeetings).length > 0) {
      Object.keys(attendanceMeetings).forEach(date => {
        let attdata = JSON.parse(attendanceMeetings[date]['attendance']);
        let itemid =[];
        itemid.push(attdata['document'],attdata['image'])
        let postdata ={
          "fileUUID" : "[" + itemid.toString() + "]"
        }
        this.submitdataSerivce.fetchUploadedFileDetails(postdata).subscribe(data=>{
          Object.entries(data).forEach(([key,value]) =>{
            let url :any = value;
            let url_split = url.split('_');
            if(url_split[2] == "document"){
              let item  = url_split[3];
              this.filename = item;
            } else{
              let item  = url_split[3];
              this.imagename = item;
            }
          })
        })
      })
    }
  }
  getFileName(fileidList){
    let postdata ={
      "fileUUID" : "[" + fileidList.toString() + "]"
    }    
    this.submitdataSerivce.fetchUploadedFileDetails(postdata).subscribe(data=>{
      let filedata = [];
      Object.entries(data).forEach(([key,value]) =>{
        let url :any = value;        
        let url_split = url.split('_');
        let item={}
        let id=key.toString();
        item['fid']=key;
        item['fname']=url_split[3];
        filedata.push(item);        
      })
      // console.log('fileData',filedata,filedata.length);
      this.fileData=filedata;
      this.setFileName(this.fileData);
    })
    
  }
  setFileName(filedata){
    if (this.fetchData && this.fetchData.length > 0){
      this.fetchData.forEach(element => {
        element['childList'].forEach(list => {
            if (list['fileUUID']!=null) {
              filedata.forEach(obj=>{
                if (obj['fid']== list['fileUUID']) {
                  
                  list['fileName']=obj['fname'];
                  // console.log("indi fileset",list['entityUUID'],list['fileUUID'],list['fileName']);
                }
              
              })
            }
            if (list['childList'] && list['childList'].length > 0) {
                list['childList'].forEach(subind => {
                  if (filedata && filedata.length > 0){
                        filedata.forEach(obj=>{
                          //console.log('object------',obj['fid']);
                          if (obj['fid']== subind['fileUUID']) {
                            subind['fileName']=obj['fname'];
                            subind['isFileName']=obj['fname'];
                            // console.log('if--subind---',subind['entityUUID'],subind['fileUUID'],subind['fileName']);
                          }
                        
                        })
                    }
                    // console.log('subind---',subind['entityUUID'],subind['fileUUID'],subind['fileName']);
              })
            }
          })
      })
    }
    this.activeSpinner = false;
    // console.log('fetchdata file nammmmm',this.fetchData);
  }
  // displayFname(Indicator){
  //   this.fileData.forEach(obj=>{
  //     console.log('object------',obj['fid']);
  //     if (obj['fid']==Indicator['fileUUID'] ) {
  //       Indicator['excelFile']=obj['fileName'];
  //       // console.log('if--subind---',subind['entityUUID'],subind['fileUUID'],subind['fileName']);
  //     }
    
  //   })

  // }

  formatminutesData(data) {
    this.attendanceFilter = {};
    if (Object.keys(data['meetings']).length > 0) {
      Object.keys(data['meetings']).forEach(tp => {
        this.attendanceFilter['mom'] = data['meetings'][tp]['mom'];
        if(data['meetings'][tp]['date']!=null && data['meetings'][tp]['date']!=""){
          this.submitStatus= true;
          this.selectedDate = this.formatAPIDate(data['meetings'][tp]['date']);
        } else{
           this.submitStatus = false;
           this.selectedDate = "Select Date"
        }
      if(data['meetings'][tp]['description']!="[]" && data['meetings'][tp]['description']!="" && data['meetings'][tp]['description']!= null && data['meetings'][tp]['description']!= undefined){       
        let label = data['meetings'][tp]['description'].split("[");        
        let labels = label[1].split("]");
        this.customFilter['cat'] = labels;
      } else{
        this.customFilter['cat'] = "";
      }
      })
    }
  }
  formatAPIDate(inputDate : any){
    let year = inputDate.substring(0,4);
    let month = inputDate.substring(4,6);
    let date = inputDate.substring(6,8);
    let newDate = year + "-" + month +"-" + date;
    return newDate;
  }
  onItemSelects(item: any) {
    this.selectedItem = [];
    this.selectedItem = item;
    this.itemselected = true;
    if (this.selectedItem && this.selectedItem['item_id'] == 'others') {
      this.showtextBox = true;
    } 
    // else {
    //   this.showtextBox = false;
    // }
    this.addItems(item, '');
    
  }
  changeMonth(value){
    console.log('valll',value);
    let dateInput = this.formInputfilter['ay'];
    dateInput = dateInput.split('-');
    
    this.monthsList.forEach(month => {
      
      if(month['key'] == this.formInputfilter['montharray']){
        if(this.formInputfilter['montharray'] > 3){
        this.minDate = { year: Number(dateInput[0]), month: Number(month['key']), day: 1 };
        this.dateObj = new Date();
        this.maxDate = { year: this.dateObj.getFullYear(), month: this.dateObj.getMonth() + 1, day: this.dateObj.getDate() }
         // this.maxDate = { year: 2023, month: 1, day: 25 }
        } else if(this.formInputfilter['montharray'] <= 3){
        this.minDate = { year: Number(dateInput[1]), month: Number(month['key']), day: 1 };
        this.dateObj = new Date();
        this.maxDate = { year: this.dateObj.getFullYear(), month: this.dateObj.getMonth() + 1, day: this.dateObj.getDate() }
         // this.maxDate = { year: 2023, month: 1, day: 25 }
      }
        
        // this.maxDate = { year: 2023, month: 1, day: 25 }

      }
    })
    this.showtextBox=false;
    this.selecteditemobj = null;

  }
  onItemDeSelects(item: any) {
    if(item!=null || item!=undefined){
      this.itemselected = true;
    } else{
      this.itemselected = false;
    }
    if (item && item['item_id'] == 'others') {
      this.showtextBox = false;
    } 
  }
  
  onItemDeSelectAlls(items: any) {
    this.itemselected = false;
    this.showtextBox = false;
  }
  onSelectAlls(items: any) {
    this.selectedItem = items;
    this.itemselected = true;
    this.selectedItem.forEach(element => {
      if (element['item_id'] == 'others') {
        this.showtextBox = true;
      }
      //  else {
      //   this.showtextBox = false;
      // }
    });
    this.addItems(items, 'all');
  }
  addItems(item, option) {
    if (option == 'all') {
      this.meetingdataArray = [];
    } else {
      for (let i = 0; i < item.length; i++) {
        this.meetingdataArray.push(item[i]);
      }
    }
  }
  getnewdataFormat(metadata) {
    this.tabledataFormat = [];
    let prefilledData=[];
    let attendanceMeetings = {};
    attendanceMeetings = metadata['meetings'];
    if (Object.keys(attendanceMeetings).length > 0) {
      Object.keys(attendanceMeetings).forEach(date => {
        let attdata = JSON.parse(attendanceMeetings[date]['attendance']);
        let parseobj = JSON.parse(attdata['data']);
        Object.keys(parseobj).forEach(item => {
          // this.tabledataFormat.push(parseobj[item]);
          prefilledData.push(parseobj[item]);
        })
      })
    }
    this.getFreezedData(prefilledData);
  }
  getFreezedData(prefilltable){
    this.attendanceTableRawData.forEach(element => {
      let prefilledEntered=false;
      prefilltable.forEach( member => {
        if (element['officials']==member['officials']){
          this.tabledataFormat.push(member);
          prefilledEntered=true;
        }
      })
      if (!(prefilledEntered))
        this.tabledataFormat.push(element);
    })
  }
  removeItems(item, option,meetingdataArray) {
    
    if (option == 'all') {
      meetingdataArray = [];
      
    } else {
      
      for (let i = 0; i < meetingdataArray.length; i++) {

        for (let j = 0; j < item.length; j++) {
          if (this.meetingdataArray[i]['item_id'] == item[j]['item_id']) {
            this.meetingdataArray.splice(i, 1)
            
          }
        }
      }
      
    }
    
  }
  uploadFileData() {
    let status = this.prevalidateAllFields();
      let filedata = this.uploadMeetingDataObj;
      let imagedata = this.imageFiles;
      let filedata2 = this.multiplefileUpload;
      let imagedata2 = this.multipleimgUpload;
      let postdata = {};
      postdata['document'] = filedata['file'];
      postdata['image'] = imagedata['photo'];
      postdata['document_a'] = filedata2['file'];
      postdata['image_a'] = imagedata2['photo'];
      // console.log("before status");
      if(this.uploadMeetingDataObj['file'] != null || this.imageFiles['photo']!=null){
        this.momentered=true;
      };
      
      if (!(this.fileselect || this.imageselect)){
        this.toastr.error("Please upload Minutes of Meeting Pdf or Image");
        this.momentered=false;
      }
      else if (this.attendanceFilter['mom'].length==0){
        this.momentered=false;
          this.toastr.error('Please enter Log of Meeting');
      }
      
      if(status && this.momentered){
        // console.log("after status");
        this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.meetingfilesData = data['data'];
        // if (!isNullOrUndefined(data)) {
          if(data.status){
            this.toastr.success(data.msg);
            this.getMeetingTableData(this.meetingfilesData);
         }  else if(data.statuscode == 420){
            this.logsrv.logoutuserandsessionclear();
          } else{
            if(data.msg == "File size exceeded for indicator id :document"){
              this.toastr.error("File size exceeds 5MB")
            } else {
              this.toastr.error("Some Exception Occurred")
            }
          }
        // }
        // this.filename = "";
        // this.imagename = "";
        // this.multiplefileName = "";
        // this.multipleimageName = "";
  
          if(data.status){
            this.modalRef = this.modalService.open(this.dataSubmissionModal,{centered:true, backdrop: 'static', keyboard: false
            });
          }
  
       });
      } else {
        this.toastr.error("Please enter necessary details properly")
      }
   
  }

  CloseVideoModal(){
    this.modalRef.dismiss();
  }

  dataSubmRoute(){
    let params = {};
    params = {'component' : 'datasubmitapprovals'};
    this.router.navigate(["/submitdata",  params]);
  }

  prevalidateAllFields(){
    if(this.showtabledata){
      for (let i = 0; i < this.tabledataFormat.length; i++) {
        // if(this.tabledataFormat[i]['officials'] != null && this.tabledataFormat[i]['officials'] !== ""){
  
          // if (isNullOrUndefined(this.tabledataFormat[i]['post']) || this.tabledataFormat[i]['post'] === '') {
          //   this.status[('post_' + i)] = true;
          //   return false;
          // } else if (isNullOrUndefined(this.tabledataFormat[i]['name']) || this.tabledataFormat[i]['name'] === '') {
          //   this.status[('name_' + i)] = true;
          //   return false;
          // } else if (isNullOrUndefined(this.tabledataFormat[i]['contactno']) || this.tabledataFormat[i]['contactno'] === '') {
          //   this.status[('contactno_' + i)] = true;
          //   return false;
          // } else
        //    if (isNullOrUndefined(this.tabledataFormat[i]['emailid']) || this.tabledataFormat[i]['emailid'] === '') {
        //     this.status[('emailid_' + i)] = true;
        //     return false;
        //   } else
            // if(isNullOrUndefined(this.tabledataFormat[i]['attendance']) || this.tabledataFormat[i]['attendance'] === ''){
            //   this.status[('attendance_'+i)] = true;
            //   return false;
            // }
        // }
        if(this.tabledataFormat[i]['officials'] == "Divisional Forest Officer"){
          if(isNullOrUndefined(this.tabledataFormat[i]['post']) || this.tabledataFormat[i]['post'] === ''){
            this.status[('post_' + i)] = true;
            this.toastr.error("Please enter name of Divisional Forest Officer")
            return false;
          } else if(isNullOrUndefined(this.tabledataFormat[i]['contactno']) || this.tabledataFormat[i]['contactno'] === ''){
            this.status[('contactno_' + i)] = true;
            this.toastr.error("Please enter contact no. of Divisional Forest Officer")
            return false;
          } else if (isNullOrUndefined(this.tabledataFormat[i]['emailid']) || this.tabledataFormat[i]['emailid'] === ''){
            this.status[('emailid_' + i)] = true;         
            this.toastr.error("Please enter email of Divisional Forest Officer")
            return false;
          } 
          else if(isNullOrUndefined(this.tabledataFormat[i]['attendance']) || this.tabledataFormat[i]['attendance']==='' || this.tabledataFormat[i]['attendance']=='no'){
            this.status[('attendance_'+i)]=true;
            this.toastr.error("Please Select attendance of Divisional Forest Officer as yes")

          }else if(this.emailvalid == true && this.tabledataFormat[i]['post'] && this.tabledataFormat[i]['contactno'] && (this.tabledataFormat[i]['attendance']=='yes')){
            return true;
          }
        }
      }

    } else if(!this.showtabledata){
      for (let i = 0; i < this.attendanceTableRawData.length; i++) {

        // if(isNullOrUndefined(this.attendanceTableRawData[i]['attendance']) || this.attendanceTableRawData[i]['attendance'] === ''){
        //   this.status[('attendance_'+i)] = true;
        //   return false;
        // }
        if (this.attendanceTableRawData[i]['officials'] == "Divisional Forest Officer") {
          if(isNullOrUndefined(this.attendanceTableRawData[i]['post']) || this.attendanceTableRawData[i]['post'] === ''){
            this.status[('post_' + i)] = true;
            this.toastr.error("Please enter name of Divisional Forest Officer")
            return false;
          } else if(isNullOrUndefined(this.attendanceTableRawData[i]['contactno']) || this.attendanceTableRawData[i]['contactno'] === ''){
            this.status[('contactno_' + i)] = true;
            this.toastr.error("Please enter contact no. of Divisional Forest Officer")
            return false;
          } else if (isNullOrUndefined(this.attendanceTableRawData[i]['emailid']) || this.attendanceTableRawData[i]['emailid'] === '') {
            this.status[('emailid_' + i)] = true;
            this.toastr.error("Please enter email of Divisional Forest Officer")
            return false;
          } else if (this.emailvalid == true && this.attendanceTableRawData[i]['post'] && this.attendanceTableRawData[i]['contactno']) {
            return true;
          }
        }
      }
    }
  }
  
  getMeetingTableData(data) {
    let descList = [];
    let attlist = [];
    let dfoDetails = {};
    this.customFilter['cat'].forEach(element => {
      if(element['item_id'] == "others"){
        element['item_text'] = this.selecteditemobj;        
      }
      if(element != undefined && element.item_text != null && element != "" && element.item_text != ""){        
        descList.push(element.item_text);        
      }      
    });
    let meetingList = [];
    this.meetingMintutes.forEach(minute => {
      meetingList.push(minute['item_id']);
    });
    if (isNullOrUndefined(this.rawdataList)) {
      this.attendanceTableRawData.forEach(element => {
        attlist.push({ "officials": element['officials'], "gender": element['gender'], "post": element['post'], "name": element['name'], "contactno": element['contactno'], "emailid": element['emailid'], "attendance": element['attendance'] });
        if(element['officials'] == "Divisional Forest Officer"){
          dfoDetails = { "officials": element['officials'], "post": element['post'], "name": element['name'], "gender": element['gender'], "contactno": element['contactno'], "emailid": element['emailid'], "attendance": element['attendance'] };
        }        
      });
    } else {
      this.tabledataFormat.forEach(element => {
        attlist.push({ "officials": element['officials'], "post": element['post'], "name": element['name'], "gender": element['gender'], "contactno": element['contactno'], "emailid": element['emailid'], "attendance": element['attendance'] });
        if(element['officials'] == "Divisional Forest Officer"){
          dfoDetails = { "officials": element['officials'], "post": element['post'], "name": element['name'], "gender": element['gender'], "contactno": element['contactno'], "emailid": element['emailid'], "attendance": element['attendance'] };
        }
      })      
    }
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay']
    postdata['date'] = this.attendanceFilter['startdate'];
    postdata['description'] = JSON.stringify(descList);
    postdata['attendance'] = JSON.stringify({ "data": JSON.stringify(attlist), "document": data ? data['document'] : null, "image": data ? data['image'] : null, "document_a": data ? data['document_a'] : null, "image_a": data ? data['image_a'] : null });
    postdata['month'] = this.formInputfilter['montharray']
    postdata['mom'] = this.attendanceFilter['mom']
    postdata['uuid'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'];
    postdata['dfo_details'] = JSON.stringify(dfoDetails);
    this.submitdataSerivce.submitmeetingdata(postdata).subscribe(data => {
      if (data.status) {
        this.toastr.success(data.msg);
        this.submitStatus = true;
      } else {
        this.toastr.error(data.msg);
        this.submitStatus = false;
      }

    })
  }

  formatBackendData(data) {
    this.rawTableData = [];
    let index = 0;
    let attendanceList = {};
    let meetingObj = {};
    attendanceList = data['meetings'];
    Object.keys(attendanceList).forEach(subtp => {
      meetingObj = attendanceList[subtp];
      if (meetingObj && meetingObj['attendance']) {
        Object.keys(meetingObj['attendance']).forEach(theme => {
          let item = {};
          index = index + 1;
          item['officials'] = meetingObj['attendance'][theme]['officials'];
          item['post'] = meetingObj['attendance'][theme]['post'];
          item['name'] = meetingObj['attendance'][theme]['name'];
          item['contactno'] = meetingObj['attendance'][theme]['contactno'];
          item['gender'] = meetingObj['attendance'][theme]['gender'];
          item['emailid'] = meetingObj['attendance'][theme]['emailid'];
          item['attendance'] = meetingObj['attendance'][theme]['attendance'];
          this.rawTableData.push(item);
        })
      }
    });
  }
  getloginBased() {
    let previnduuid = this.getKeyByValue(this.currentindlist, this.currentId);
    this.fetchData.forEach(element => {
      element['childList'].forEach(indlist => {
        if (indlist['entityUUID'] == previnduuid) {
          this.fetchSubIndicator(indlist);
        }
      });
    });
  }
  getpreviousIndicators() {
    let previnduuid = this.getKeyByValue(this.currentindlist, this.currentId);
    this.fetchData.forEach(element => {
      if (element['label'] == "Public Awareness") {
        element['childList'].forEach(indlist => {
          if (indlist['entityUUID'] == previnduuid) {
            this.fetchSubIndicator(indlist);
          }
        });
      }
    });
  }
  getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }
  keyPressAlphanumericData(event) {
    let alnumdata = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z0-9]/.test(alnumdata)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  keyPress(event: any,contact) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) && contact.length != 10) {
      event.preventDefault();
    }
  }
  restrictCommas(event) {
    let theEvent = event || window.event;
    let key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[^,;]+$/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) {
        theEvent.preventDefault();
      }
    }
  }
  inputTypeWetLand(e, i) {
    this.wetLandList[i]['atfwlc'] = e.target.value;
  }
  addstpbooleanlist() {
    this.stpBooleanDatalist.push({ stpn: '', nact: '', dprp: '', pa: '', ut: '', urn: '', uom: '', fileUUID: '', serialNo: '' })
  }
  keyPressAlphaNumericWithCharacters(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z0-9-. ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  addspringBox() {
    if (this.mandatoryChecksforsprings()) {
      this.springBisunessDataList.push({ sprn: '', atfrs: '', scors: null, fileUUID: '', serialNo: '' });
    } else {
      this.toastr.error("Fill out the required fields  before adding new record");
    }
  }
  removeSubIndTextdata(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.subIndicatorList.splice(index, 1);
      }
    })
  }
  removebooleanlist(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.stpBooleanDatalist.splice(index, 1);
      }
    })
  }
  removeSpringBox(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.springBisunessDataList.splice(index, 1);
      }
    })
  }
  inputtypespring(e, i) {
    this.springBisunessDataList[i]['scors'] = e.target.value;
  }
  inputtypeSelected(e, i) {
    this.grossDataList[i]['etpp'] = e.target.value;
  }
  inputtypeSelecteds(e, i) {
    this.grossDataList[i]['dcw'] = e.target.value
  }
  inputTypeIndustry(e, i) {
    this.industryDataList[i]['nact'] = e.target.value
  }
  inputTypeIndustry1(e, i) {
    this.industryDataList[i]['epani'] = e.target.value
  }
  inputTypeIndustry2(e, i) {
    this.industryDataList[i]['ihbc'] = e.target.value
  }
  inputTypeIndustry3(e, i) {
    this.industryDataList[i]['indclsr'] = e.target.value
  }
  inputTypeNalla(e, i) {
    this.nallaDataList[i]['td'] = e.target.value;
  }
  inputTypeNalla1(e, i) {
    this.nallaDataList[i]['cubrn'] = e.target.value;
  }
  addGrossDataBox() {
    if (this.mandatoryChecksforgrossdatalist()) {
      this.grossDataList.push({ indn: '', sect: '', etpp: null, dcw: null, fileUUID: '', serialNo: '' });
    } else {
      this.toastr.error("Fill out the required fields  before adding new record");
    }
  }
  removeGrossData(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.grossDataList.splice(index, 1);
      }
    })
  }
  removeindustryData(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.industryDataList.splice(index, 1);
      }
    })
  }
  addindustryData() {
    if (this.mandatoryChecksforindustrydatalist()) {
      this.industryDataList.push({ indn: '', nact: null, epani: null, ihbc: null, indclsr: null, fileUUID: '', serialNo: '' });
    } else {
      this.toastr.error("Fill out the required fields  before adding new record");
    }

  }
  addnallaData() {
    if (this.prevalidationObject()) {
      this.nallaDataList.push({ nln: '', td: null, cubrn: null, fileUUID: '', serialNo: '' })
    } else {
      this.toastr.error("Fill out the required fields  before adding new record");
    }
  }
  removenallaData(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.nallaDataList.splice(index, 1);
      }
    })
  }
  addStpData() {
    this.stpDataList.push({ stpn: '', stpc: '', custpc: '', mds: null, dcgmc: '', pcstpu: '', fileUUID: '', serialNo: '' });
  }
  removeStpData(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.stpDataList.splice(index, 1);
      }
    })
  }
  removestpdata(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.stpPercentageDataList.splice(index, 1);
      }
    })
  }
  removestpBooleanData(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.stpBooleanDataList.splice(index, 1);
      }
    })
  }
  addstpBooleanData() {
    // if(this.prevalidation()){
    this.stpBooleanDataList.push({ stpn: '', nact: '', dprp: '', pa: '', ut: '', urn: '', uom: '', fileUUID: '', serialNo: '' })
    // } else{
    //   this.toastr.error("Fill out the required fields  before adding new record");
    // }
  }
  addstpdata() {
    if (this.mandatoryChecksforstpdata()) {
      this.stpPercentageDataList.push({ stpn: '', flfc: '', asic: '', fileUUID: '', serialNo: '' })
    } else {
      this.toastr.error("Fill out the required fields  before adding new record");
    }
  }
  removeWaterData(index) {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.waterReusedDataList.splice(index, 1);
      }
    })
  }
  addWaterData() {
    if (this.prevalidationChecks()) {
      this.waterReusedDataList.push({ stpn: '', custpc: '', tr: '', cmrcl: '', cnsrn: '', agcl: '', grdng: '', onp: '', fileUUID: '', serialNo: '' })
    } else {
      this.toastr.error("Fill out the required fields  before adding new record");
    }
  }
  statusFix() {
    this.status = {};
    for (let i = 0; i < this.subIndicatorList.length; i++) {
      this.status[('nln_' + i)] = false;
      this.status[('rtfall_' + i)] = false;
      this.status[('sin_' + i)] = false;
      this.status[('fd_' + i)] = false;
      this.status[('file_' + i)] = false;
    }
  }
  prevalidationObject() {
    for (let i = 0; i < this.nallaDataList.length; i++) {
      if (isNullOrUndefined(this.nallaDataList[i]['nln']) || this.nallaDataList[i]['nln'] === '') {
        this.status[('nln_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.nallaDataList[i]['td']) || this.nallaDataList[i]['td'] === '') {
        this.status[('td_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.nallaDataList[i]['cubrn']) || this.nallaDataList[i]['cubrn'] === '') {
        if(this.nallaDataList[i]['td'] == 'no'){
        this.status[('cubrn_' + i)] = true;
        return false;
        }
      }
    }
    return true;
  }
  validatePlanlabel(){
    for (let i = 0; i < this.planDataList.length; i++) {
      if (isNullOrUndefined(this.planDataList[i]['stpn']) || this.planDataList[i]['stpn'] === '') {
        this.status[('stpn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.planDataList[i]['stpc']) || this.planDataList[i]['stpc'] === '') {
        this.status[('stpc_' + i)] = true;
        return false;
      }
    }
    return true;
  }
  prevalidation() {
    for (let i = 0; i < this.stpBooleanDataList.length; i++) {
      if (isNullOrUndefined(this.stpBooleanDataList[i]['stpn']) || this.stpBooleanDataList[i]['stpn'] === '') {
        this.status[('stpn_' + i)] = true;
        return false;
      // } else if (isNullOrUndefined(this.stpBooleanDataList[i]['custpc']) || this.stpBooleanDataList[i]['custpc'] === '') {
      //   this.status[('custpc_' + i)] = true;
      //   return false;
      } else if (isNullOrUndefined(this.stpBooleanDataList[i]['nact']) || this.stpBooleanDataList[i]['nact'] === '') {
        this.status[('nact_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpBooleanDataList[i]['dprp']) || this.stpBooleanDataList[i]['dprp'] === '') {
        this.status[('dprp_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpBooleanDataList[i]['pa']) || this.stpBooleanDataList[i]['pa'] === '') {
        this.status[('pa_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpBooleanDataList[i]['ut']) || this.stpBooleanDataList[i]['ut'] === '') {
        this.status[('ut_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpBooleanDataList[i]['urn']) || this.stpBooleanDataList[i]['urn'] === '') {
        this.status[('urn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpBooleanDataList[i]['uom']) || this.stpBooleanDataList[i]['uom'] === '') {
        this.status[('uom_' + i)] = true;
        return false;
      }
      // } else if(isNullOrUndefined(this.stpBooleanDataList[i]['file']) || this.stpBooleanDataList[i]['file'] === ''){
      //   this.status[('file_'+ i)] = true;
      //   return false;
      // }
    }
    return true;
  }
  stpyesPreValidation(){
    for (let i = 0; i < this.stpdataformat.length; i++) {
      if (isNullOrUndefined(this.stpdataformat[i]['stpn']) || this.stpdataformat[i]['stpn'] === '') {
        this.status[('stpn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpdataformat[i]['stpc']) || this.stpdataformat['stpc'] === '') {
        this.status[('stpc_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpdataformat[i]['mds']) || this.stpdataformat[i]['mds'] === '') {
        this.status[('mds_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpdataformat[i]['dcgmc']) || this.stpdataformat[i]['dcgmc'] === '') {
        this.status[('dcgmc' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpdataformat[i]['pcstpu']) || this.stpdataformat[i]['pcstpu'] === '') {
        this.status[('pcstpu_' + i)] = true;
        return false;
      } 
    }
    return true;
  }
  stpnoPreValidation() {
    for (let i = 0; i < this.stpBooleanDatalist.length; i++) {
      if (isNullOrUndefined(this.stpBooleanDatalist[i]['stpn']) || this.stpBooleanDatalist[i]['stpn'] === '') {
        this.status[('stpn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpBooleanDatalist[i]['nact']) || this.stpBooleanDatalist[i]['nact'] === '') {
        this.status[('nact_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpBooleanDatalist[i]['dprp']) || this.stpBooleanDatalist[i]['dprp'] === '') {
        this.status[('dprp_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpBooleanDatalist[i]['pa']) || this.stpBooleanDatalist[i]['pa'] === '') {
        this.status[('pa_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpBooleanDatalist[i]['ut']) || this.stpBooleanDatalist[i]['ut'] === '') {
        this.status[('ut_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpBooleanDatalist[i]['urn']) || this.stpBooleanDatalist[i]['urn'] === '') {
        this.status[('urn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpBooleanDatalist[i]['uom']) || this.stpBooleanDatalist[i]['uom'] === '') {
        this.status[('uom_' + i)] = true;
        return false;
      }
      // } else if(isNullOrUndefined(this.stpBooleanDataList[i]['file']) || this.stpBooleanDataList[i]['file'] === ''){
      //   this.status[('file_'+ i)] = true;
      //   return false;
      // }
    }
    for (let i = 0; i < this.stpdatavalueformat.length; i++) {
      if (isNullOrUndefined(this.stpdatavalueformat[i]['stpn']) || this.stpdatavalueformat[i]['stpn'] === '') {
        this.status[('stpn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpdatavalueformat[i]['stpc']) || this.stpdatavalueformat[i]['stpc'] === '') {
        this.status[('nact_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpdatavalueformat[i]['custpc']) || this.stpdatavalueformat[i]['custpc'] === '') {
        this.status[('dprp_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpdatavalueformat[i]['mds']) || this.stpdatavalueformat[i]['mds'] === '') {
        this.status[('pa_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpdatavalueformat[i]['dcgmc']) || this.stpdatavalueformat[i]['dcgmc'] === '') {
        this.status[('ut_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpdatavalueformat[i]['pcstpu']) || this.stpdatavalueformat[i]['pcstpu'] === '') {
        this.status[('urn_' + i)] = true;
        return false;
      } 
    }
    return true;
  }
  prevalidationChecks() {
    for (let i = 0; i < this.waterReusedDataList.length; i++) {
      if (isNullOrUndefined(this.waterReusedDataList[i]['stpn']) || this.waterReusedDataList[i]['stpn'] === '') {
        this.status[('stpn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.waterReusedDataList[i]['custpc']) || this.waterReusedDataList[i]['custpc'] === '') {
        this.status[('custpc_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.waterReusedDataList[i]['tr']) || this.waterReusedDataList[i]['tr'] === '') {
        this.status[('tr_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.waterReusedDataList[i]['cmrcl']) || this.waterReusedDataList[i]['cmrcl'] === '') {
        this.status[('cmrcl_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.waterReusedDataList[i]['cnsrn']) || this.waterReusedDataList[i]['cnsrn'] === '') {
        this.status[('cnsrn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.waterReusedDataList[i]['agcl']) || this.waterReusedDataList[i]['agcl'] === '') {
        this.status[('agcl_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.waterReusedDataList[i]['grdng']) || this.waterReusedDataList[i]['grdng'] === '') {
        this.status[('grdng_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.waterReusedDataList[i]['onp']) || this.waterReusedDataList[i]['onp'] === '') {
        this.status[('onp_' + i)] = true;
        return false;
      }
      // } else if(isNullOrUndefined(this.waterReusedDataList[i]['file']) || this.waterReusedDataList[i]['file'] === ''){
      //   this.status[('file_'+ i)] = true;
      //   return false;
      // }
    }
    return true;
  }
  preValidation() {
    for (let i = 0; i < this.subIndicatorList.length; i++) {
      if (isNullOrUndefined(this.subIndicatorList[i]['nln']) || this.subIndicatorList[i]['nln'] === '') {
        this.status[('nln_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.subIndicatorList[i]['fd']) || this.subIndicatorList[i]['fd'] === '') {
        this.status[('fd_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.subIndicatorList[i]['rtfall']) || this.subIndicatorList[i]['rtfall'] === '') {
        this.status[('rtfall_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.subIndicatorList[i]['sin']) || this.subIndicatorList[i]['sin'] === '') {
        this.status[('sin_' + i)] = true;
        return false;
      }
    }
    return true;
  }
  statusFixForRiverdata() {
    this.status = {};
    for (let i = 0; i < this.subIndicatorList.length; i++) {
      this.status[('srn_' + i)] = false;
      this.status[('nactrjv_' + i)] = false;
      this.status[('ptrp_' + i)] = false;
      this.status[('rau_' + i)] = false;
      this.status[('losrr_' + i)] = false;
      this.status[('file_' + i)] = false;
    }
  }
  mandatoryChecks() {
    for (let i = 0; i < this.smallRiverList.length; i++) {
      if (isNullOrUndefined(this.smallRiverList[i]['srn']) || this.smallRiverList[i]['srn'] === '') {
        this.status[('srn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.smallRiverList[i]['nactrjv']) || this.smallRiverList[i]['nactrjv'] === '') {
        this.status[('nactrjv_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.smallRiverList[i]['ptrp']) || this.smallRiverList[i]['ptrp'] === '') {
        this.status[('ptrp_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.smallRiverList[i]['rau']) || this.smallRiverList[i]['rau'] === '') {
        this.status[('rau_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.smallRiverList[i]['losrr']) || this.smallRiverList[i]['losrr'] === '') {
        this.status[('losrr_' + i)] = true;
        return false;
      }
    }
    return true;
  }
  statusFixforWetland() {
    this.status = {};
    for (let i = 0; i < this.wetLandList.length; i++) {
      this.status[('wlnl_' + i)] = false;
      this.status[('wlsz_' + i)] = false;
      this.status[('atfwlc_' + i)] = false;
      this.status[('file_' + i)] = false;
    }
  }
  mandatoryChecksforwetland() {
    for (let i = 0; i < this.wetLandList.length; i++) {
      if (isNullOrUndefined(this.wetLandList[i]['wlnl']) || this.wetLandList[i]['wlnl'] === '') {
        this.status[('wlnl_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.wetLandList[i]['wlsz']) || this.wetLandList[i]['wlsz'] === '') {
        this.status[('wlsz_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.wetLandList[i]['atfwlc']) || this.wetLandList[i]['atfwlc'] === '') {
        this.status[('atfwlc_' + i)] = true;
        return false;
      }
    }
    return true;
  }
  statusFixforspringList() {
    this.status = {};
    for (let i = 0; i < this.springBisunessDataList.length; i++) {
      this.status[('sprn_' + i)] = false;
      this.status[('atfrs_' + i)] = false;
      this.status[('scors_' + i)] = false;
      this.status[('file_' + i)] = false;
    }
  }
  mandatoryChecksforsprings() {
    for (let i = 0; i < this.springBisunessDataList.length; i++) {
      if (isNullOrUndefined(this.springBisunessDataList[i]['sprn']) || this.springBisunessDataList[i]['sprn'] === '') {
        this.status[('sprn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.springBisunessDataList[i]['atfrs']) || this.springBisunessDataList[i]['atfrs'] === '') {
        this.status[('atfrs_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.springBisunessDataList[i]['scors']) || this.springBisunessDataList[i]['scors'] === '') {
        this.status[('scors_' + i)] = true;
        return false;
      }
    }
    return true;
  }
  statusFixforgrossList() {
    this.status = {};
    for (let i = 0; i < this.grossDataList.length; i++) {
      this.status[('indn_' + i)] = false;
      this.status[('sect_' + i)] = false;
      this.status[('file_' + i)] = false;
    }
  }
  mandatoryChecksforgrossdatalist() {
    for (let i = 0; i < this.grossDataList.length; i++) {
      if (isNullOrUndefined(this.grossDataList[i]['indn']) || this.grossDataList[i]['indn'] === '') {
        this.status[('indn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.grossDataList[i]['sect']) || this.grossDataList[i]['sect'] === '') {
        this.status[('sect_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.grossDataList[i]['etpp']) || this.grossDataList[i]['etpp'] === '') {
        this.status[('etpp_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.grossDataList[i]['dcw']) || this.grossDataList[i]['dcw'] === '') {
        this.status[('dcw_' + i)] = true;
        return false;
      }
    }
    return true;
  }
  mandatoryChecksforindustrydatalist() {
    for (let i = 0; i < this.industryDataList.length; i++) {
      if (isNullOrUndefined(this.industryDataList[i]['indn']) || this.industryDataList[i]['indn'] === '') {
        this.status[('indn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.industryDataList[i]['nact']) || this.industryDataList[i]['nact'] === '') {
        this.status[('nact_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.industryDataList[i]['epani']) || this.industryDataList[i]['epani'] === '') {
        this.status[('epani_' + i)] = true;
        return false;
      } else if ((isNullOrUndefined(this.industryDataList[i]['ihbc']) || this.industryDataList[i]['ihbc'] === '')
       && (isNullOrUndefined(this.industryDataList[i]['indclsr']) || this.industryDataList[i]['indclsr'] === '')) {
        // if(this.industryDataList[i]['ihbc']){
          this.status[('indclsr_' + i)] = true;
          this.status[('ihbc_' + i)] = true;
          return false;
        // } else if(this.industryDataList[i]['indclsr']){
          // return false;
        // }
        
      // } else if (isNullOrUndefined(this.industryDataList[i]['indclsr']) || this.industryDataList[i]['indclsr'] === '') {
      //   this.status[('indclsr_' + i)] = true;
      //   return false;
      }
    }
    return true;
  }
  mandatoryChecksforstpdata() {
    for (let i = 0; i < this.stpPercentageDataList.length; i++) {
      if (isNullOrUndefined(this.stpPercentageDataList[i]['stpn']) || this.stpPercentageDataList[i]['stpn'] === '') {
        this.status[('stpn_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpPercentageDataList[i]['flfc']) || this.stpPercentageDataList[i]['flfc'] === '') {
        this.status[('flfc_' + i)] = true;
        return false;
      } else if (isNullOrUndefined(this.stpPercentageDataList[i]['asic']) || this.stpPercentageDataList[i]['asic'] === '') {
        this.status[('asic_' + i)] = true;
        return false;
      }
    }
    return true;
  }


  focusEvent(e, value) {
    if ((value === null || value === undefined || value === '')) {
      // this.status[e.target.id] = true;
    } else {
      this.status[e.target.id] = false;
    }
  }


  getIndicatorsHeirarchy(from) {
    if (this.basicValidation()) {
      this.activeSpinner = true;
      this.formInputfilter['type'] = this.userlocationtype
      this.submitdataSerivce.FetchIndicators(this.formInputfilter).subscribe(data => {
        this.viewForm = true;
        this.rawdata = data;
        this.heirarchydata = data;
        // this.addbusinessdatatohierarchy(this.heirarchydata);
        let obj = {};
        if (Object.keys(this.theme).length > 0 && from != 'fromhtml') {
          this.heirarchydata.forEach(element => {
            if (element.entityUUID == this.theme['entityUUID']) {
              obj = element;
            }
          });
        } else {
          obj = this.heirarchydata[0]
        }
        this.activeTheme(obj['label'])
        this.loadIndicators(obj);
        this.activeSpinner = false;
      });
    } else {
      this.viewForm = false;
      this.heirarchydata = [];
    }
  }
  getIndicatorsBusData(from) {
    if (this.basicValidation()) {
      this.activeSpinner = true;
      let postdata = {};
      postdata = this.getbasicparams();
      this.submitdataSerivce.getIndicatorsBusData(postdata).subscribe(data => {
        this.indicatorhierarchyData = data['data'];
      });
      this.activeSpinner = false;
    }
  }
  activeThemes(label) {
    for (let value of this.fetchData) {
      if (value.label == label) {
        value['class'] = "active";
      } else {
        value['class'] = ''
      }
    }
  }
  getcurrentBusinessData() {
    this.imagename="";
    this.filename="";
    this.indicatorThemes = {};
    this.customFilter = {};
    // this.onItemDeSelectAlls;
    this.indicatorflag = true;
    this.nullLabels();
    this.activeSubIndicators = [];
    if (this.mandatoryCheck()) {
      this.activeSpinner = true;
      let postdata = {};
      postdata = this.getbasicparams();
      this.submitdataSerivce.getIndicatorsBusData(postdata).subscribe(data => {
        this.indicatorhierarchyData = data['data'];
        this.fetchIndicators();
        this.getuploadedRawData();
      });
      this.activeSpinner = false;
    }
  }
  fetchIndicators() {
    if (this.basicvalidation()) {
      this.activeSpinner = true;
      this.formInputfilter['type'] = this.userlocationtype
      this.submitdataSerivce.FetchIndicators(this.formInputfilter).subscribe(data => {
        this.fetchData = [];
        this.viewform = true;
        data.forEach(element => {
          element['open'] = false;
        });
        this.fetchData = this.formatfetchData(data); //fetchData has district api data
        // console.log('fetchdata',this.fetchData);
        this.fetchmeetingData();
        this.disableThemes();
        this.enableMandateThemes();
        this.getIndicatorData(this.fetchData)
        this.activeSpinner = false;
      });

    }
  }

  enableMandateThemes(){
    let payload = {
      "aY": this.formInputfilter['ay'],
      "cUUID": "f78f615d-e270-4f93-90ac-27608e756b85",
      "pUUID": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "component":1,
      "cType":"DISTRICT",
      "subTp":this.formInputfilter['montharray']
    }
    this.submitdataSerivce.getEnabledThemes(payload).subscribe(result=>{
      this.enabledThemes = JSON.parse(result['data']);
      // console.log("before if",this.enabledThemes);
      if(this.enabledThemes != null){        
        this.fetchData.forEach(baseTheme =>{
          this.enabledThemes.forEach(compTheme =>{
            if(baseTheme['entityUUID'] == compTheme['id']){
              baseTheme['mandate'] = true;
              // console.log("basetheme",baseTheme);        
            }
          })
        })
      }      
    })    
  }

  formatfetchData(data) {
    // console.log('data',data);
    if (data && data.length > 0)
      data.forEach(element => {
        if (element['childList']) {
          element['childList'].forEach(indicator => {
            if (indicator['label'] && indicator['label'] == "Percentage gap between Solid waste generated & solid waste actually treated in the town- across all ULBs within the district") {
              indicator['sno'] = "2.10";
            }
          });
        }
      });
    return this.sortingdata(data);
  }
  sortingdata(data) {
    if (data && data.length > 0)
      data.forEach(element => {
        if (element['childList'] && element['childList'].length > 0) {
          element['childList'].sort((a, b) => {
            let sno1 = parseInt(a['sno'].replace('.', ''));
            let sno2 = parseInt(b['sno'].replace('.', ''));
            return sno1 > sno2 ? 1 : -1;
          })
        }
      });
    return data;
  }
  getIndicatorData(rawdata) {
    this.activeSpinner = true;
    this.fileIDList = [];
    if (rawdata && rawdata.length > 0)
      rawdata.forEach(element => {
        element['childList'].forEach(list => {
          if (this.indicatorhierarchyData!=undefined){ //indicators prefilled data
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators]
                // if (stateindicators['id'] == "33f5f6f2-ab37-4997-8a54-25ce66e913fb") {
                //   console.log('chillistlllll',stateindicators['cd']);
                // }
                if (stateindicators['id'] == list['entityUUID']) {
                  list['value'] = stateindicators['value'];
                  if(stateindicators['id'] == "06780eb6-c1c8-4bc0-a8e5-1112d80091b9" && stateindicators['value'] == "yes"){
                    if(stateindicators['cmt'] != null){
                      list['foc'] = stateindicators['cmt']['foc'];
                    }
                  } else if(stateindicators['id'] == "9f9618fa-3c04-49c2-9e9a-bed5c6a35ce7" && stateindicators['value'] == "yes"){
                    if(stateindicators['cmt'] != null){
                      list['foc'] = stateindicators['cmt']['foc'];
                    }
                  } else if(stateindicators['id'] == "1c4ced52-e6b7-46f0-9c5d-c6c0fbb0bb63" && stateindicators['value'] == "yes"){
                    if(stateindicators['cmt'] != null){
                      list['nomh'] = stateindicators['cmt']['nomh'];
                      list['noi'] = stateindicators['cmt']['noi'];
                    }                    
                  }
                  if (stateindicators['fileUUID']!=null){
                    list['fileUUID']=stateindicators['fileUUID'];
                    this.fileIDList.push(stateindicators['fileUUID']);
                  }
                  if (stateindicators['cd']) { 
                    stateindicators['cd'].forEach(chd=>{
                    //console.log("objj",obj['fileUUID'],obj);
                    if (chd['fileUUID']!=null)
                      this.fileIDList.push(chd['fileUUID']);                    
                    })
                  }
                  if (list['childList'] && list['childList'].length > 0) {
                    list['childList'].forEach(subind => {
                      subind['subindflag'] = true;
                      if (stateindicators && stateindicators['cd']) {
                        stateindicators['cd'].forEach(childlist => {

                          if (childlist['id'] == subind['entityUUID']) {
                            subind['value'] = childlist['value'];     
                            if(childlist['label'] == "Mass awareness meetings held (If Yes- No of meetings held)" && childlist['value'] == "yes"){
                              subind['nomh'] = childlist['nomh'];
                            }                       
                            if (childlist['fileUUID']!=null){
                              subind['fileUUID']=childlist['fileUUID'];
                              this.fileIDList.push(childlist['fileUUID']);
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          })
        }
        })
      });

      if (this.fileIDList.length>0){
        this.getFileName(this.fileIDList);
      }
      // this.setFileName(this.fileData);
  }
  tabcolapse(e) {
    let panel;
    let perentactive;
    if (e.target.parentNode.tagName == 'A') {
      panel = e.target.parentNode.nextSibling;
      perentactive = e.target.parentNode;
    } else {
      panel = e.target.nextSibling;
      perentactive = e.target;
    }
    if (panel) {
      if (panel.className.search('show') == -1) {
        panel.classList.add('show');
        perentactive.classList.add('active');
      } else {
        panel.classList.remove('show');
        perentactive.classList.remove('active');
      }
      this.loadIndicatorsThemes(e);
    }
  }
  loadIndicatorsThemes(e) {
    this.fetchData.forEach(element => {
      element['childList'].forEach(list => {
        this.indicatorsList.push(list);

      });
    });

  }
  togg() {
    return this.toggle_menu = !this.toggle_menu;
  }
  collapseAll(theme) {
    this.fetchData.forEach(element => {      
      if(theme['sno'] == element['sno']){
        element['open'] = !element['open'];
        // console.log("themee",element['sno'],element['open']);
      } else if(theme['sno'] != element['sno']){
        element['open'] = false;
        // console.log("falsetheme",element['sno'],element['open']);        
      }
    });
    
    // this.indicatorList = [];
    // this.fetchData.forEach(element => {
    //   if (element['label'] == "Public Awareness") {
    //     element['childList'].forEach(indlist => {
    //       this.indicatorList.push(indlist)
    //     });
    //   }
    // });
  }
  public fileNameCheck(filename) {
    filename = filename.split('.');
    if (filename[filename.length - 1] === 'pdf' || filename[filename.length - 1] === 'PDF') {
      return true;
    } else {
      return false;
    }
  }
  public fileimgNameCheck(filename) {
    filename = filename.split('.');
    if (filename[filename.length - 1] === 'jpg' || filename[filename.length - 1] === 'jpeg' || filename[filename.length - 1] === 'png' || filename[filename.length - 1] === 'JPG' || filename[filename.length - 1] === 'JPEG') {
      return true;
    } else {
      return false;
    }
  }
  fileupload(event) {
    if (event.target.files.length == 0) {
      this.buttondisable = false;
    } else {
      this.buttondisable = true;
    }
    this.outputerror = '';
    if (event.target.files.length > 0) {
      this.fileselect = true;
      this.filename = event.target.files[0].name;
      if (this.fileNameCheck(event.target.files[0].name)) {
        this.uploadMeetingDataObj['file'] = event.target.files[0];
        // console.log(this.uploadMeetingDataObj['file'])
      } else {
        this.uploadMeetingDataObj['file'] = null;
      }
    } else {
      this.uploadMeetingDataObj['file'] = null;
    }
  }
  getimageoption() {
    this.showimageoption = true;
  }
  getimageFilter() {
    this.showimageoption = false;
    this.multipleimgUpload['photo'] = null;
  }
  getanotherFile() {
    this.showfile = true
  }
  getfileFilter() {
    this.showfile = false;
    this.multiplefileUpload['file'] = null;
  }
  multipleFile(event) {
    this.outputerror = '';
    if (event.target.files.length > 0) {
      this.multiplefileName = event.target.files[0].name;
      if (this.fileNameCheck(event.target.files[0].name)) {
        this.multiplefileUpload['file'] = event.target.files[0];
      } else {
        this.multiplefileUpload['file'] = null;
      }
    } else {
      this.multiplefileUpload['file'] = null;
    }
  }

  imageupload(event) {
    if (event.target.files.length == 0) {
      this.imagedisable = false;
    } else {
      this.imagedisable = true;
      this.imageselect=true;
    }
    this.outputerror = '';
    if (event.target.files.length > 0) {
      this.imagename = event.target.files[0].name;
      if (this.fileimgNameCheck(event.target.files[0].name)) {
        this.imageFiles['photo'] = event.target.files[0];
        this.imageselect=true;
      } else {
        this.imageFiles['photo'] = null;
      }
    } else {
      this.imageFiles['photo'] = null;
    }
  }
  multiplefileImages(event) {
    this.outputerror = '';
    if (event.target.files.length > 0) {
      this.multipleimageName = event.target.files[0].name;
      if (this.fileimgNameCheck(event.target.files[0].name)) {
        this.multipleimgUpload['photo'] = event.target.files[0];

      } else {
        this.multipleimgUpload['photo'] = null;
      }
    } else {
      this.multipleimgUpload['photo'] = null;
    }
  }
  fetchmeetingData() {
    this.currentId = '';
    this.nullLabels();
    
    this.indicatorflag = true;
    this.meetingflag = false;
    this.activeSubIndicators = [];
    // this.indicatorList = [];
    this.meetingSendData = this.fetchData[10]['label'] == "Meeting at DGC "
    // this.getuploadedRawData();
    // }
    // })
  }
  nullLabels(){
    this.dynamiclabel = null;
    this.mediaLabels = null;
    this.solidwaste = null;
    this.ghatslabel = null;
    this.engagedlabel = null;
    this.gangagramlabel = null;
    this.afferostationlabel = null;
    this.migratorylabel = null;
    this.pondslabel = null;
    this.meetingsDGC = null;
    this.percentagelabel = null;
    this.gangalabel = null;
    this.educatinglabel = null;
    this.dynamicindLabel = null;
    this.inspectionlabel = null;
    this.authoritylabel = null;
    this.solidwastehotspot = null;
    this.plasticwastehotspot = null;
    this.adequatelabel = null;
    this.igolabel = null;
    this.soilconvlabel = null;
    this.stablisedlabel = null;
    this.gannurlabel = null;
    this.medicinelabel = null;
    this.capacitylabel = null;
    this.stpmanage = null;
    this.fecalsludge = null;
    this.regularmeetinglabel = null;
    this.dgclabel = null;
    this.gangaaarti = null;
    this.gangaapp = null;
    this.awarenesss = null;
    this.migratorylabel = null;
    this.gangasafety = null;
    this.yearlylabel = null;
    this.masterlabel = null;
    this.rivercentric = null;
    this.wastedumplabel = null;
    this.riverbanklabel = null;
    this.ngoLabel = null;
    this.cremtorialLabel = null;
    this.villagepop = null;
    this.swachsurukshen = null;
    this.statuslabel = null;
    this.biodiversity = null;
    this.budgetaccounts = null;
    this.vacancyaccounts = null;
    this.bhuvanapp = null;
    this.planlabel = null;
    this.indicatorLabel = null;
    this.indicatordata = null;
    this.wetlandData = null;
    this.springRejuvendData = null;
    this.GrossData = null;
    this.industryData = null;
    this.nallaData = null;
    this.stpData = null;
    this.stpPercentageData = null;
    this.reusageWaterData = null;

  }
  disableThemes() {
    this.themeflag = [];
    this.fetchData.forEach((theme, index) => {
      if (theme['label'] == "Public Awareness" || theme['label'] == "Meeting at DGC ") {
        this.themeflag[index] = false;
      } else {
        this.themeflag[index] = true;
      }
    });
  }
  fetchSubIndicator(themeData){
    if(themeData['label'] == "Public Outreach Activities Undertaken"){
      this.prevbutton = true;
    } else{
      this.prevbutton = false;
    }

    if(themeData['label'] == "Spring Rejuvenation"){
      this.nextbutton = true;
    } else{
      this.nextbutton = false;
    }
    this.indicatorflag = false;
    this.meetingflag = true;
    this.selectedFiles = {};
    this.indicatorselectedFile = {};
    this.showbuttons = true;
    // this.showIndicatorData = true;
    this.indicatorThemes = {};
    this.indicatorThemes = themeData;
    // console.log("indicatorThemes--",this.indicatorThemes);
    this.currentId = themeData['entityUUID'];
    this.indicatorremove = themeData['hasData'];
    this.activeSubIndicators = themeData['childList'];
    // console.log("activSUbb",this.activeSubIndicators);
    this.meetingdateobj = this.indicatorThemes ? this.indicatorThemes['label'] == "Date Of The Meeting" : null;
    this.ngoLabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Involvement of NGOs in recycling of Pooja/Floral waste in the town" :null;
    this.plasticwastehotspot = this.indicatorThemes ? this.indicatorThemes['label'] == "Plastic Waste Hotspot mapping has been done across all ULBs within the district" : null;
    this.bhuvanapp = this.indicatorThemes ? this.indicatorThemes['label'] == "Whether Bhuvan Ganga App is used" : null;
    this.vacancyaccounts = this.indicatorThemes ? this.indicatorThemes['label'] == "Vacancy in District Ganga Committee" : null;
    this.budgetaccounts = this.indicatorThemes ? this.indicatorThemes['label'] == "Budget and maintenance of accounts is done" : null;
    this.rivercentric = this.indicatorThemes ? this.indicatorThemes['label'] == "River centric special projects included in masterplans" : null;
    this.masterlabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Master plan for towns greater then 10 Lakhs of population exist" : null;
    this.yearlylabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Yearly sand mining plan prepared" : null;
    this.gangasafety = this.indicatorThemes ? this.indicatorThemes['label'] == "Ganga Safety audits are conducted" : null;
    this.awarenesss = this.indicatorThemes ? this.indicatorThemes['label'] == "Awareness campaigns or capacity building activities conducted to preserve the Biodiversity" : null;
    this.biodiversity = this.indicatorThemes ? this.indicatorThemes['label'] == "District Biodiversity register created by Biodiversity Board in the district" : null;
    this.gangaapp = this.indicatorThemes ? this.indicatorThemes['label'] == "Whether Jan Ganga App is used by Ganga Gram to update the activities" : null;
    this.statuslabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Status and availability of Ganga Praharis, Ganga Mitra/ Volunteer" : null;
    this.swachsurukshen = this.indicatorThemes ? this.indicatorThemes['label'] == "Ganga gram Swachh Survekshan is conducted" : null;
    this.gangaaarti = this.indicatorThemes ? this.indicatorThemes['label'] == "Ganga Aarti are conducted in Ganga grams" : null;
    this.villagepop = this.indicatorThemes ? this.indicatorThemes['label'] == "For all villages with population more the 10k if there exists solid and liquid waste management (SLWM) plan" : null;
    this.dgclabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Surprise inspection visits made by DGC (District Ganga Committee ) / authorising officer" : null;
    this.regularmeetinglabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Whether regular meetings are held with industries (If Yes- No of meetings held and name of industries)" : null;
    this.planlabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Availability of fecal sludge treatment plants" : null;
    this.fecalsludge = this.indicatorThemes ? this.indicatorThemes['label'] == "Availability of plant for co- treatment of fecal sludge in existing STPs" : null
    this.stpmanage = this.indicatorThemes ? this.indicatorThemes['label'] == "Conducted surprise visits to STPs for monitoring operation and management of STP" : null
    this.gannurlabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Ganga Nursery development" : null
    this.medicinelabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Medicinal and Aromatic Plants" : null
    this.capacitylabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Capacity building and awareness activities conducted related to Afforestation" : null
    this.stablisedlabel = this.indicatorThemes ? this.indicatorThemes['label'] == "River Bank Stabilisation activities" : null
    this.soilconvlabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Soil conservation activities conducted" : null
    this.devlabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Development of Cremetoria (Newly constructed or Renovated)" : null
    this.wastedumplabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Presence of Legacy waste dump near river banks/ river flood plain across all ULBs within the district" : null
    this.adequatelabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Adequate twin litterbins have been installed in every 50 meter of river Ghats" : null
    this.solidwastehotspot = this.indicatorThemes ? this.indicatorThemes['label'] == "Solid waste hotspot mapping of Ganga River town has been done across all ULBs within the district" : null
    this.riverbanklabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Presence of open Dumpsites near river banks/ river flood plain across all ULBs within the district" : null
    this.authoritylabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Regular cleaning of Ghats is happening / Frequency" : null
    this.inspectionlabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Surprise inspection made by assigned authorities" : null
    this.ulblabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Whether regular cleaning / disposal of solid waste undertaken and monitored in all ULBs within the district/Frequency of Cleaning" : null;
    this.dynamicindLabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Whether regular cleaning / disposal of solid waste undertaken and monitored in all ULBs within the district" : null
    this.igolabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Involvement of NGOs in recycling of Pooja/Floral waste in the towm" : null
    this.educatinglabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Educating Schools, College & Communities for conserving habitats of Ganga River" : null
    this.gangalabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Ganga Aartis are conducted in the district" : null
    this.migratorylabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Sighting of Migratory birds" : null
    this.pondslabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Ponds utilised for the production of fisheries" : null
    this.engagedlabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Endangered species in the district" : null
    this.gangagramlabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Toilets constructed across Ganga Grams near river Ganga" : null
    this.afferostationlabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Afforestation Activities in river bank area" : null
    this.percentagelabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Percentage of dead bodies cremated in electrical crematorium" : null
    this.ghatslabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Development of Ghats" : null
    this.solidwaste = this.indicatorThemes ? this.indicatorThemes['label'] == "Percentage gap between Solid waste generated & solid waste actually treated in the town- across all ULBs within the district" : null;
    this.dynamiclabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Public Outreach Activities Undertaken" : null;
    this.indicatorLabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Number of Nalla's in the district flowing into tributaries or Ganga directly" : null;
    this.indicatordata = this.indicatorThemes ? this.indicatorThemes['label'] == "Small River rejuvenation" : null;
    this.wetlandData = this.indicatorThemes ? this.indicatorThemes['label'] == "Wetland conservation" : null;
    this.springRejuvendData = this.indicatorThemes ? this.indicatorThemes['label'] == "Spring Rejuvenation" : null;
    this.GrossData = this.indicatorThemes ? this.indicatorThemes['label'] == "List of Gross Polluting Industries (GPI)" : null;
    this.industryData = this.indicatorThemes ? this.indicatorThemes['label'] == "Action taken against non-compliant Industries" : null;
    this.nallaData = this.indicatorThemes ? this.indicatorThemes['label'] == "Tapping of Nalla's" : null;
    this.cremtorialLabel = this.indicatorThemes ? this.indicatorThemes['label'] == "Development of Cremetoria - Newly constructed or Renovated (Percentage Complettion of Work)" : null;
    this.stpData = this.indicatorThemes ? this.indicatorThemes['label'] == "Are all STPs in the district operational" : null;
    this.stpPercentageData = this.indicatorThemes ? this.indicatorThemes['label'] == "Percentage of work completed for new STPs under construction" : null;
    this.reusageWaterData = this.indicatorThemes ? this.indicatorThemes['label'] == "Reuse of treated waste water for different purposes mentioned below" : null;
    this.mediaLabels = this.indicatorThemes ? this.indicatorThemes['label'] == "Media Publicity" : null;
    this.meetingsDGC = this.indicatorThemes ? this.indicatorThemes['label'] == "Number of meetings held of DGC" : null;
    if (this.indicatorLabel) {
      this.getdynamicIndicators();
    }
    if (this.indicatordata) {
      this.getTableDataforriver();
    }
    if (this.wetlandData) {
      this.getTableDataforwetLands();
    }
    if (this.springRejuvendData) {
      this.getTableDataforsprings();
    }
    if (this.GrossData) {
      this.getTableDataforGross();
    }
    if (this.industryData){
      this.getTableDataforIndustry();
    }
    if (this.nallaData) {
      this.getTableDataforNalla();
    }
    if (this.stpData && this.indicatorThemes['value'] == "yes") {
      //console.log('gettable data');
      this.gettabledataforboolean();
    }
    // } else if(this.stpData && this.stpboolean){
    //     this.gettabledataforSTP();
    // }
    if (this.stpPercentageData) {
      this.percentagetableData();
    }
    if (this.reusageWaterData) {
      this.tabledatausage();
    }
    if (this.planlabel){
      this.getplanData();
    }
  }
  getdynamicIndicators() {
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if (childlist['isDynamic'] && stateindicators['id'] == "5a809e2a-f7a0-40be-9272-edf01e41ca83") {
                      this.subIndicatorList.forEach(element => {
                        element['nln'] = childlist['nln'];
                        element['fd'] = childlist['fd'];
                        element['sin'] = childlist['sin'];
                        element['rtfall'] = childlist['rtfall'];
                        if (childlist['fileUUID'] && childlist['fileUUID']!=null){
                          element['fileUUID']=childlist['fileUUID'];
                              if (this.fileData && this.fileData.length > 0){
                                this.fileData.forEach(obj=>{
                                  if (obj['fid']== childlist['fileUUID']) {
                                    element['fileName']=obj['fname'];
                                  }
                                
                                })
                              }

                        }
                      })
                    }
                  });
                }
              });
            });
          });
        }
      });
    });
  }
  getTableDataforriver() {
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if (childlist['isDynamic'] && stateindicators['id'] == "33f5f6f2-ab37-4997-8a54-25ce66e913fb") {
                      for (let i = 0; i < this.smallRiverList.length; i++) {
                        this.smallRiverList[i]['srn'] = childlist['srn'];
                        this.smallRiverList[i]['nactrjv'] = childlist['nactrjv'];
                        this.smallRiverList[i]['rau'] = childlist['rau'];
                        this.smallRiverList[i]['ptrp'] = childlist['ptrp'];
                        this.smallRiverList[i]['losrr'] = childlist['losrr'];
                        if (childlist['fileUUID'] !=null && childlist['fileUUID']!=''){
                          this.smallRiverList[i]['fileUUID']=childlist['fileUUID'];
                          if (this.fileData && this.fileData.length > 0){
                            this.fileData.forEach(obj=>{
                              if (obj['fid']== childlist['fileUUID']) {
                                this.smallRiverList[i]['fileName']=obj['fname'];
                              }
                            
                            })
                          }
                      }
                      }
                    }
                  });
                }
              });
            });
          });
        }
      });
    });
    // console.log('smallllllll',this.smallRiverList);
  }
  getTableDataforwetLands() {
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if (childlist['isDynamic'] && stateindicators['id'] == "4c3b8a65-6850-4f2e-99b4-df40b2ded196") {
                      this.wetLandList.forEach(landlist => {
                        landlist['wlnl'] = childlist['wlnl'];
                        landlist['wlsz'] = childlist['wlsz'];
                        landlist['atfwlc'] = childlist['atfwlc'];
                        landlist['fileUUID']=childlist['fileUUID'];
                        if (this.fileData && this.fileData.length > 0){
                          this.fileData.forEach(obj=>{
                            if (obj['fid']== childlist['fileUUID']) {
                              landlist['fileName']=obj['fname'];
                            }
                          
                          })
                      }

                      })
                    }
                  });
                }
              });
            });
          });
        }
      });
    });
  }
  getTableDataforsprings() {
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if (childlist['isDynamic'] && stateindicators['id'] == "b47be2e0-4536-43e6-9f9e-f890e6cf6219") {
                      this.springBisunessDataList.forEach(list => {
                        list['atfrs'] = childlist['atfrs'];
                        list['scors'] = childlist['scors'];
                        list['sprn'] = childlist['sprn'];
                        if (childlist['fileUUID'] && childlist['fileUUID']!=null){
                            list['fileUUID']=childlist['fileUUID'];
                            if (this.fileData && this.fileData.length > 0){
                              this.fileData.forEach(obj=>{
                                if (obj['fid']== childlist['fileUUID']) {
                                  list['fileName']=obj['fname'];
                                }
                              
                              })
                            }
                         }
                      })
                    }
                  });
                }
              });
            });
          });
        }
      });
    });
  }
  getTableDataforGross() {
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if (childlist['isDynamic'] && stateindicators['id'] == "e78ddb62-199f-45dc-863f-9e47e5332142") {
                      this.grossDataList.forEach(list => {
                        list['dcw'] = childlist['dcw'];
                        list['etpp'] = childlist['etpp'];
                        list['indn'] = childlist['indn'];
                        list['sect'] = childlist['sect'];
                      })
                    }
                  });
                }
              });
            });
          });
        }
      });
    });
  }
  getTableDataforIndustry() {
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if (childlist['isDynamic'] && stateindicators['id'] == "584aff29-c5be-4b33-bc97-a6c3f0165f8b") {
                      this.industryDataList.forEach(element => {
                        element['epani'] = childlist['epani'];
                        element['ihbc'] = childlist['ihbc'];
                        element['indclsr'] = childlist['indclsr'];
                        element['nact'] = childlist['nact'];
                        element['indn'] = childlist['indn'];
                        if (childlist['fileUUID']!=null){
                          element['fileUUID']=childlist['fileUUID'];
                          if (this.fileData && this.fileData.length > 0){
                            this.fileData.forEach(obj=>{
                              if (obj['fid']== childlist['fileUUID']) {
                                element['fileName']=obj['fname'];
                              }
                            
                            })
                          }

                        }
                      })
                    }
                  });
                }
              });
            });
          });
        }
      });
    });
  }
  getTableDataforNalla() {
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if (childlist['isDynamic'] && stateindicators['id'] == "547911e6-f2ca-4201-9772-6b8c907607fa") {
                      this.nallaDataList.forEach(data => {
                        data['cubrn'] = childlist['cubrn'];
                        data['nln'] = childlist['nln'];
                        data['td'] = childlist['td']
                      })
                    }
                  });
                }
              });
            });
          });
        }
      });
    });
  }
  gettabledataforSTP() {
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if (childlist['isDynamic'] && this.indicatorThemes['label'] == "Are all STPs in the district operational") {
                      this.stpDataList.forEach(array => {
                        array['custpc'] = childlist['custpc'];
                        array['dcgmc'] = childlist['dcgmc'];
                        array['mds'] = childlist['mds'];
                        array['pcstpu'] = childlist['pcstpu'];
                        array['stpc'] = childlist['stpc'];
                        array['stpn'] = childlist['stpn'];
                      });
                    }
                  });
                }
              });
            });
          });
        }
      });
    });
  }
  changeStartDate(value) {
    if(this.selectedDate!=null){
      this.showinputButton = true;
    } else{
      this.showinputButton = false;
    }
    this.selectedDate = value;
    this.dateSelected = true;
    this.attendanceFilter['startdate'] = this.sendBackendData(value);
  }
  sendBackendData(date: any): any {
    let year = date.year;
    let month = date.month;
    let day = date.day;
    if (parseInt(month) < 10) {
      month = "0" + month.toString();
    }

    if (day < 10) {
      day = "0" + day.toString();
    }
    return year.toString() + month + day;
  }
  gettabledataforboolean() {
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if (childlist['isDynamic'] && stateindicators['id'] == "1122dd8d-33cd-4c54-af8e-8039dd051089") {
                      this.stpBooleanDataList.forEach(obj => {
                        obj['dprp'] = childlist['dprp'];
                        //console.log('obj[dprp]',obj['dprp']);
                        obj['nact'] = childlist['nact'];
                        obj['pa'] = childlist['pa'];
                        obj['stpn'] = childlist['stpn'];
                        obj['uom'] = childlist['uom'];
                        obj['urn'] = childlist['urn'];
                        obj['ut'] = childlist['ut'];
                      })
                    }
                  });
                }
              });
            });
          });
        }
      });
    });
  }
  percentagetableData() {
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if (childlist['isDynamic'] && stateindicators['id'] == "4c8fbb97-dce6-42e8-9a49-7e9928ccd001") {
                      this.stpPercentageDataList.forEach(obj => {
                        obj['stpn'] = childlist['stpn'];
                        //console.log('reusage obj[stpn]',obj['stpn']);
                        obj['flfc'] = childlist['flfc'];
                        obj['asic'] = childlist['asic'];
                      })
                    }
                  });
                }
              });
            });
          });
        }
      });
    });
  }
  tabledatausage() {
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if (childlist['isDynamic'] && stateindicators['id'] == "9cc78229-8d89-4877-afe5-263afe7c6fda") {
                      this.waterReusedDataList.forEach(list => {
                        list['agcl'] = childlist['agcl'];
                        list['cmrcl'] = childlist['cmrcl'];
                        list['cnsrn'] = childlist['cnsrn'];
                        list['custpc'] = childlist['custpc'];
                        list['grdng'] = childlist['grdng'];
                        list['onp'] = childlist['onp'];
                        list['stpn'] = childlist['stpn'];
                        list['tr'] = childlist['tr']
                      })
                    }
                  });
                }
              });
            });
          });
        }
      });
    });
  }
  getplanData(){
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          Object.keys(this.indicatorhierarchyData).forEach(assesment => {
            Object.keys(this.indicatorhierarchyData[assesment]).forEach(subtime => {
              Object.keys(this.indicatorhierarchyData[assesment][subtime]).forEach(indicators => {
                let stateindicators = this.indicatorhierarchyData[assesment][subtime][indicators];
                if (stateindicators['id']=="16af077d-cdc0-4b2a-a747-ecf0fd565fd6" && stateindicators['cd']) {
                  stateindicators['cd'].forEach(childlist => {
                    if(childlist['id']!=null){
                      this.planDataList.forEach(list=>{
                        list['stpn']=childlist['stpn'];
                        list['stpc']=childlist['stpc'];

                      })

                    }
                  });
                }
              });
            });
          });
        }
      });
    });

  }
  themeValueChange(themeData) {
    themeData['valuechanged'] = true;
  }
  booleanValueChange(themeData, type) {
    //console.log('theme',themeData,this.stpDatavalue);
        if (type == "boolean") {
      themeData['valuechanged'] = true;
      themeData['editable'] = false;
    }
    if (themeData['valuechanged']) {
      themeData['editable'] = false;
      this.stpDatavalue = themeData ? themeData['value'] == "yes" : null;
      this.stpDatavalue2 = themeData ? themeData['value'] == "no" : null;
      // this.yesclickValue = themeData ? themeData['value'] == "no":null;
      this.stpboolean = themeData ? themeData['value'] == "no" : null;
    }

  }
  getLocationList() {
    let option = {
      'pType': this.constants.LOCATION_CONSTANT['STATE'],
      'cType': this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': this.formInputfilter['lu']
    };
    this.activeSpinner = true;
    this.submitdataSerivce.getLocationListforUser(option).subscribe(data => {
      this.activeSpinner = false;
      if (Array.isArray(data)) {
        this.fieldDropDownList['DistrictList'] = data;
      } else
        this.fieldDropDownList['DistrictList'] = [];

    }, function (err) {
      this.activeSpinner = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    });
  }
  checkfileUpload() {
    let returnflag = true;
    this.heirarchydata.forEach(element => {
      element['childList'].forEach(list => {
        if (list['childList'] != null) {
          let flag = false;
          list['childList'].forEach(numdemlist => {
            if (numdemlist['valuechanged']) {
              flag = true;
            }

          });
          if (flag && !list['fileSelected']) {
            list['showFileError'] = true;
            returnflag = false;
          } else {
            list['showFileError'] = false;

          }

        } else {
          if (list['valuechanged'] && !list['fileSelected']) {
            list['showFileError'] = true;
            returnflag = false;
          } else {
            list['showFileError'] = false;
          }

        }

      });
    });

    return returnflag;
  }
  // checkNumdenValues(row){
  //   if(row['editable'] && parseFloat(row[1]['value'])< parseFloat(row[0]['value'])){
  //     row['IsNumBig'] = true; 
  //   } else{
  //     row['IsNumBig'] = false
  //   }
  //    }
  public basicValidation(): boolean {
    this.validation[0] = this.utils.checkfield(this.formInputfilter['ay'])
    if (this.formInputfilter['datasubmit'] == 'districtwise')
      this.validation[1] = this.utils.checkfield(this.formInputfilter['distuuid'])
    else
      this.validation[1] = true;
    return this.validation[0] && this.validation[1];
  }
  getAssesmentYear(year) {
    this.fieldDropDownList['AssesmentList'] = this.submitdataSerivce.getassesmentYear();
    if (this.userdetails && this.userdetails['roles'][0] == 'DISTRICT_GANGA_COMMITTEE') {
      this.fieldDropDownList['AssesmentListDistrict'] = this.submitdataSerivce.getAssesmentYearDistrict();

    }
    let urlParams = this.utils.getWritableObject(this.route.snapshot.params);
    this.formInputfilter['ay'] = year ? year : "";
  }
  async getassesmentunit() {
    let options = {
      "st": this.formInputfilter['lu'],
      "userId": this.userdetails['loggedUserData'].userProfile.userId
    }
    this.showdistdropdown = await this.submitdataSerivce.getAssesmentData(options);
    this.activeSpinner = false;
    // this.showdistdropdown= true;
    this.districtflag = false;
    if (this.showdistdropdown) {
      this.getLocationList()
    }
  }
  restrictZero(event: any, value) {
    if (value['type'] == 'denominator') {
      if (event.target.value.length == 0 && event.key === "0") {
        event.preventDefault();
        value = null;
      }
    }
  }
  checkValidNumDen(row) {
    if (!isNullOrUndefined(row['childList'])) {
      if (parseFloat(row['childList'][1]['value']) >= parseFloat(row['childList'][0]['value'])) {
        return true
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  isFiniteC(value) {
    return isFinite(value);
  }
  validations(rows, numdenrow) {
    numdenrow['isNumBig'] = false
    this.selectedrow = rows;
    if (parseFloat(rows[1]['value']) < parseFloat(rows[0]['value'])) {
      // rows[1]['value'] = null;
      numdenrow['isNumBig'] = true;
    }
  }
  validationCheck(rows, numdenrow) {
    numdenrow['isNumBig'] = false
    this.selectedrow = rows;
    if (parseFloat(rows[1]['updatedValue']) < parseFloat(rows[0]['updatedValue'])) {
      // rows[1]['value'] = null;
      numdenrow['isNumBig'] = true;
    }
  }
  indicatorFileUpload(event, id) {
    // console.log('indicatorfileupload',event.target.files,id);
    this.outputerror = '';
    if (event.target.files.length > 0) {
      this.indicatorThemes['selectedFile'] = event.target.files[0].name;
      this.fileId = id;
      if (this.checkTypeOfFile(event.target.files[0].name)) {
        this.indicatorThemes['fileupload'] = true;
        this.indicatorThemes['valuechanged']=true;
        this.indicatorselectedFile[id] = event.target.files[0];
        this.selectedFiles=this.indicatorselectedFile;
      } else {
        this.indicatorThemes['fileupload'] = false;
        this.indicatoruploadData['chooseFile'] = null;
      }
    } else {
      this.indicatoruploadData['chooseFile'] = null;
    }
  }
  indicatorfileRemove(){
    this.modalRef = this.modalService.open(RemovefilePopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this file ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.indicatorThemes['fileupload'] = false;
         this.indicatorThemes['selectedFile'] = "";
         this.fileId = ""
      }
    })
  }
  loadIndicators(list) {
    let options = {
      "cType": this.userlocationtype == 'DISTRICT' ? this.constants.LOCATION_CONSTANT['DISTRICT'] : this.constants.LOCATION_CONSTANT['STATE'],
      "ay": this.formInputfilter['ay'],
      "lu": this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'],
      "view": this.constants.VIEWS['admin']
    }
    this.submitdataSerivce.getthemeweight(options).subscribe(data => {
      if (data.length > 0) {
        data.forEach(theme => {
          if (theme.entityUUID == list.entityUUID) {
            list.weight = theme.weight;
          }
        });
      }
    });
    let i = 0;
    this.disablebuttons = true;
    list['childList'].forEach(indlist => {

      if (indlist['year'] != this.prevyr && !indlist['editable']) {

        i++;
      }
    });
    if (i > 0) {
      this.disablebuttons = false;
    }
    this.theme = list;
  }
  filechoosen(event, entityUUID, row) {
    // console.log("filechoosen",event.target.files,entityUUID);
    
    this.outputerror = '';
    if(event.target.files.length > 0){    
      row['isFileName'] = event.target.files[0].name;
      row['fileId'] = entityUUID;
      if(this.checkTypeOfFile(event.target.files[0].name)){
        row['fileSelected'] = true;
        // row['isFileUpload'] == true;
        row['itemchanged']=true;
        row['valuechanged']=true;
        this.selectedFiles[entityUUID] = event.target.files[0];
        //console.log("filechosen uuid",entityUUID);
      }else{
        row['fileSelected'] = false;

        this.selectedFiles = null;
      }
    }
    else{
      this.selectedFiles = null;
    }
  }
  removechosenfile(row){
    this.modalRef = this.modalService.open(RemovefilePopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this file ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        row['isFileName'] = "";
        row['fileId']="";
        row['fileSelected'] = false;
        row['excelFile'] = '';
        row['isFileSelect']="";
        row['valuechanged'] = false;
      }
    })
  }

  
removefilerecord(row) {
    this.modalRef = this.modalService.open(RemovefilePopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this file ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        row['isFileSelect']="";
        row['fileselected'] = false;
        row['fileId']="";
        //row['excelFile'] = '';
        this.exceluploadData['excelFile'] = null;
        this.selectedFile='';
        //console.log("row ----",row);
      }
    })
  }
  fileChoosen(event, rowname, row) {
    // this.fileList['file_' + rowname] = event.target.files[0];
    this.fileList['file' + rowname] = event.target.files[0];
    this.outputerror = '';
    this.selectedFile.push(event.target.files[0].name);
    row['isFileSelect'] = event.target.files[0].name; 
    // row['fileName']=event.target.file[0].name;
    row['fileId'] = rowname;
    // console.log("row",row,rowname,this.selectedFile);
    
    if (event.target.files.length > 0) {
      if (this.checkTypeOfFile(event.target.files[0].name)) {
        row['fileselected'] = true;
        row['valuechanged']=true;
        //console.log('fileselecte',row['fileselected']);
        this.exceluploadData['excelFile'] = event.target.files[0];
        //console.log('excel-',this.exceluploadData['excelFile']);
        // this.validation[4] = true;
      } else {
        row['fileselected'] = false;
        // this.validation[4] = false;
        this.exceluploadData['excelFile'] = null;
      }
    } else {
      this.validation[4] = false;
      this.exceluploadData['excelFile'] = null;
    }
    this.selectedCharacter.push(rowname);    
  }
  getCharacter(key) {
    let obj = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    return obj[key];
  }
  public checkTypeOfFile(filename) {
    filename = filename.split('.');
    if (filename[filename.length - 1] === 'xls' || filename[filename.length - 1] === 'xlsx' || filename[filename.length - 1] === 'pdf' || filename[filename.length - 1] === 'jpg' || filename[filename.length - 1] === 'jpeg' || filename[filename.length - 1] === 'png' || filename[filename.length - 1] === 'docx' || filename[filename.length - 1] === 'ppt' || filename[filename.length - 1] === 'pptx'|| filename[filename.length - 1] === 'JPG' || filename[filename.length - 1] === 'jpeg'|| filename[filename.length - 1] === 'jpg') {
      return true;
    } else {
      return false;
    }
  }
  addbusinessdatatohierarchy(rawdata) {
    // this.theme = list;
    this.currentyr = this.formInputfilter['ay'];
    this.prevyr = this.submitdataSerivce.getPrevYear(this.currentyr);
    rawdata.forEach(list => {
      list['childList'].forEach(element => {
        if (element['year'] == this.currentyr) {
          if (this.businessdata[this.currentyr].length > 0) {
            this.businessdata[this.currentyr].forEach(indicators => {
              if (indicators['id'] == element['entityUUID']) {
                element['value'] = indicators['value'];
                element['editable'] = !indicators['editable'];
                if (element['childList'] && element['childList'].length > 0) {
                  element['childList'][0]['value'] = indicators['numerator'];
                  element['childList'][1]['value'] = indicators['denominator'];
                  element['childList'][0]['updatedValue'] = indicators['updatedNumerator'];
                  element['childList'][1]['updatedValue'] = indicators['updatedDenominator'];
                  element['childList'][0]['isUpdatedValue'] = indicators['numerator'] ? true : false;
                  element['childList'][1]['isUpdatedValue'] = indicators['denominator'] ? true : false;
                  element['childList'][0]['isUpdatedValue'] = indicators['updatedNumerator'] ? true : false;
                  element['childList'][1]['isUpdatedValue'] = indicators['updatedDenominator'] ? true : false;

                }
                if (indicators['editable'] && element['ip'] == "BOOLEAN" && indicators['value']) {
                  element['value'] = indicators['value'].toLowerCase();
                }
              }
            });
          }
        } else {
          if (element['year'] == this.prevyr) {
            element['disableprvyvalue'] = true;
            if (this.businessdata[this.prevyr].length > 0) {
              this.businessdata[this.prevyr].forEach(indicators => {
                if (indicators['id'] == element['entityUUID']) {
                  element['value'] = indicators['value'];
                  if (element['childList'] && element['childList'].length > 0) {
                    element['childList'][0]['numerator'] = indicators['numerator'];
                    element['childList'][1]['denominator'] = indicators['denominator'];

                  }
                }
              });
            }
          }
        }
      });
    });
  }
  indicatorvaluechange(row, type) {
    if (type == "boolean")
      row['value'] = row['value'] == "yes" ? "no" : "yes";
    row['valuechanged'] = false;
    let value = this.getcurrentbusdata(row);
    this.indicatorData = value

    if (value != row['value']) {
      row['valuechanged'] = true;
    }
  }
  subindicatorvaluechange(row, type) {
    if (type == "boolean") {
      row['valuechanged'] = true;
      row['editable'] = true;
    }

  }
  indicatorValuechange(row) {
    // console.log(row,"bbbb");
    
    if (row) {
      row['valuechanged'] = true;
      row['editable'] = true;
    }
  }

  getcurrentbusdata(row) {
    let value = null
    if (row['year'] == this.currentyr) {
      this.businessdata[this.currentyr].forEach(element => {
        if (element['id'] == row['entityUUID']) {
          // row['type'] != 'numerator' && row['type'] != 'denominator'
          value = row['type'] == 'numerator' ? element['numerator'] : (row['type'] == 'denominator' ? element['denominator'] : element['value']);
        }

      });
    }
    return value;
  }
  checkZero(rows) {
    if (rows[1]['value'] == '0') {
      rows[1]['value'] = '';

    }

  }

  // submitindicatorsdata(uuid){
  //   let postdata = {};
  //   let checkdata = this.checkifindicatordatachanged();
  //   if(checkdata['status']){
  //     let data = checkdata['totaldata'];
  //     postdata = this.getbasicparams();
  //     postdata['data'] = JSON.stringify(checkdata['totaldata'])
  //     postdata['ts'] = new Date().getTime();
  //     this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data =>{
  //       if(data.status){
  //         let msg;
  //     if(!isNullOrUndefined(data['data'])){
  //     msg = data['data'][Object.keys(data['data'])[0]][0]
  //      this.toastr.error(msg);
  //     }
  //   else{
  //        msg=data['msg']
  //       this.toastr.success(msg);
  //     }
  //         this.initializeOnStateLoad(this.formInputfilter['ay']);
  //       } else if(data.statuscode == 420){
  //         this.logsrv.logoutuserandsessionclear();
  //       } else {
  //         this.toastr.error(data.msg);
  //       }
  //     });
  //   } else {
  //     this.toastr.error('Please change atleast one indicator data')
  //   }

  // }
  submitData(fileuploadData) {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray']
    postdata['data'] = JSON.stringify(this.uploadSubIndicators(fileuploadData));
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
        this.selectedFiles = {};
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  bisunessData() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploadBisunessData());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });

  }
  uploadexcelBisunessData() {
    let status = this.preValidation();
    if (status == true) {
      let postdata = this.fileList;
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.fileuploadData = data.data;
        if (!isNullOrUndefined(this.fileuploadData)) {
          Object.keys(this.fileuploadData).forEach(key => {
            this.fileUUIDList.push(this.fileuploadData[key]);
          })
        }
        this.bisunessData();
      });
    } else {
      this.toastr.error("Fill out the required fields before saving");
    }
  }
  riverBisunessData() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploadRiversData());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'];
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  uploadexcelriverData() {
    //console.log("uploaded");
    let status = this.mandatoryChecks();
    if (status == true) {
      let postdata = this.fileList;
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.fileuploadData = data.data;
        if (!isNullOrUndefined(this.fileuploadData)) {
          Object.keys(this.fileuploadData).forEach(key => {
            this.fileUUIDList.push(this.fileuploadData[key]);
          })
          // this.riverBisunessData();
        }
        this.riverBisunessData();
      });
    } else {
      this.toastr.error("Fill out the required fields before saving");
    }
  }
  industryBisunessData() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploadindustryData());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'];
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  uploadexcelindustryData() {
    let status = this.mandatoryChecksforindustrydatalist();
    if (status == true) {
      let postdata = this.fileList;
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.fileuploadData = data.data;
        if (!isNullOrUndefined(this.fileuploadData)) {
          Object.keys(this.fileuploadData).forEach(key => {
            this.fileUUIDList.push(this.fileuploadData[key]);
          })
        }
        this.industryBisunessData();
      });
    } else {
      this.toastr.error("Fill out the required fields before saving");
    }
  }
  springBisunessData() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploadbisunessData());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  uploadexcelSpringFile() {
    let status = this.mandatoryChecksforsprings();
    if (status == true) {
      let postdata = this.fileList;
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.fileuploadData = data.data;
        if (!isNullOrUndefined(this.fileuploadData)) {
          Object.keys(this.fileuploadData).forEach(key => {
            this.fileUUIDList.push(this.fileuploadData[key]);
          })
        }
        this.springBisunessData();
      });
    } else {
      this.toastr.error("Fill out the required fields before saving");
    }
  }
  wetLandBisunessData() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploadWetLandData());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });

  }
  uploadexcelWetlandData() {
    let status = this.mandatoryChecksforwetland();
    let postdata = this.fileList;
    if (status == true) {
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.fileuploadData = data.data;
        if (!isNullOrUndefined(this.fileuploadData)) {
          Object.keys(this.fileuploadData).forEach(key => {
            this.fileUUIDList.push(this.fileuploadData[key]);
          })
        }
        this.wetLandBisunessData();
      });
    } else {
      this.toastr.error("Fill out the required fields before saving");
    }
  }
  grossBisunessData() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uplaodgrosBisunessData());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  uploadgrossData() {
    let status = this.mandatoryChecksforgrossdatalist();
    if (status == true) {
      let postdata = this.fileList;
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.fileuploadData = data.data;
        if (!isNullOrUndefined(this.fileuploadData)) {
          Object.keys(this.fileuploadData).forEach(key => {
            this.fileUUIDList.push(this.fileuploadData[key]);
          })
        }
        this.grossBisunessData();
      });
    } else {
      this.toastr.error("Fill out the required fields before saving");
    }
  }
  nallaBisunessData() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uplaodnallaBisunessData());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  uploadNallaData() {
    let status = this.prevalidationObject();
    if (status == true) {
      let postdata = this.fileList;
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.fileuploadData = data.data;
        if (!isNullOrUndefined(this.fileuploadData)) {
          Object.keys(this.fileuploadData).forEach(key => {
            this.fileUUIDList.push(this.fileuploadData[key]);
          })
        }
        this.nallaBisunessData();
      });
    } else {
      this.toastr.error("Fill out the required fields before saving");
    }
  }
  planlabelBusinessData(){
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uplaodplanBisunessData());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  uplaodplanBisunessData(): any {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          for (let i = 0; i < this.planDataList.length; i++) {
            // this.planDataList[i]['fileUUID'] = this.fileUUIDList[i];
            this.planDataList[i]['serialNo'] = this.selectedCharacter[i];
          }
          for (let i = 0; i < this.planDataList.length; i++) {
            delete this.planDataList[i]['file']
          }
          let childList = this.planDataList;
          obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'],"fileUUID":this.fileUUIDList[0], "childData": childList })
        }
      });
    });
    return obj;
  }
 
  uploadPlanlabelData(){
    // console.log('upload plan labeldata');
    let status = this.validatePlanlabel();
    if(status == true ){
      let postdata = this.indicatorselectedFile;
      // console.log('post--',this.indicatorselectedFile);
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        // console.log("5.7777",data['data']);
        // console.log("55555.7",data.data);
        this.fileuploadData = data.data;
        if(!isNullOrUndefined(this.fileuploadData)){
          Object.keys(this.fileuploadData).forEach(key => {
            this.fileUUIDList.push(this.fileuploadData[key]);
          })
        }
        this.planlabelBusinessData();
      });
    }
    else {

      this.toastr.error("Fill out the required fields before saving");
    }
  }
  stpBisunessData() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uplaodStpBisunessData());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if (data.status) {
        this.toastr.success(data.msg)
      }
    });
  }
  // uploadsewaragedata() {
  //   let postdata = this.fileList;
  //   this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
  //     this.fileuploadData = data.data;
  //     //console.log("zczc",data);
      
  //     if (!isNullOrUndefined(this.fileuploadData)) {
  //       Object.keys(this.fileuploadData).forEach(key => {
  //         this.fileUUIDList.push(this.fileuploadData[key]);
  //         // console.log("ddssdd",this.fileUUIDList);
          
  //       })
  //     }
  //     this.sewaragebisunessdata();
  //   });
  // }
  
  uploadsewaragedata() {
    //console.log('sewerage data upload');
    let status = this.stpyesPreValidation();
    if (status == true) {
    
      let postdata = this.fileList;
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.fileuploadData = data.data;
        //console.log("zczc",data);
        
        if (!isNullOrUndefined(this.fileuploadData)) {
          Object.keys(this.fileuploadData).forEach(key => {
            this.fileUUIDList.push(this.fileuploadData[key]);
            // console.log("ddssdd",this.fileUUIDList);
            
          })
        }
        this.sewaragebisunessdata();
      });
    }else{
      this.toastr.error("Fill out the required fields before saving");
    }
  }
  // uploadfunctinaldata() {
  //   let postdata = this.fileList;
  //   this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
  //     this.fileuploadData = data.data;
  //     if (!isNullOrUndefined(this.fileuploadData)) {
  //       Object.keys(this.fileuploadData).forEach(key => {
  //         this.fileUUIDList.push(this.fileuploadData[key]);
  //       })
  //     }
  //     this.sewaragefunctinaldata();
  //   });
  // }
  uploadfunctinaldata() {
    let status = this.stpnoPreValidation();
    if (status == true) {
      let postdata = this.fileList;
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.fileuploadData = data.data;
        if (!isNullOrUndefined(this.fileuploadData)) {
          Object.keys(this.fileuploadData).forEach(key => {
            this.fileUUIDList.push(this.fileuploadData[key]);
          })
        }
        this.sewaragefunctinaldata();
      });
    }
    else {
        this.toastr.error("Fill out the required fields before saving");
      }
  }
  sewaragefunctinaldata() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploaddataformatting());
    //console.log('postdata[data]',postdata['data']);
    
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  sewaragebisunessdata() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploadingdataFormat());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  uploadingdataFormat() {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(list => {
        if (this.currentId == list['entityUUID']) {
          if (list['childList'] && list['childList'].length > 0) {
            // for (let i = 0; i < this.stpBooleanDataList.length; i++) {
            //   delete this.stpBooleanDataList[i]['file']
            // }
            for (let i = 0; i < this.stpdataformat.length; i++) {
              this.stpdataformat[i]['fileUUID'] = this.fileUUIDList[i];
              this.stpdataformat[i]['serialNo'] = this.selectedCharacter[i];
              delete this.stpdataformat[i]['file'];
            }
            // let childList = this.stpdataformat;
            // console.log("childlit",this.stpdataformat);
            
            //if (this.indicatorThemes && this.indicatorThemes['value'] == "yes") {
            // obj[this.formInputfilter['ay']].push({ "id": list['childList'][0]['entityUUID'], "value": null, "childData": this.stpdataformat }, { "id": list['entityUUID'], "value": list['value'] });
            //}
            //console.log('indicatorthemes[value]---',this.indicatorThemes['value']);
            // obj[this.formInputfilter['ay']].push({ "id": list['childList'][0]['entityUUID'], "value": this.indicatorThemes['value'], "childData": this.stpdataformat }, { "id": list['entityUUID'], "value": list['value'] });
            obj[this.formInputfilter['ay']].push({ "id": list['childList'][1]['entityUUID'], "value": this.indicatorThemes['value'], "childData": this.stpdataformat }, { "id": list['entityUUID'], "value": list['value'] });
            // obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childList })
          
          }
        }
      })
    });
    //console.log('return obj',obj);
    return obj;
  }
  uploaddataformatting() {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(list => {
        if (this.currentId == list['entityUUID']) {
          if (list['childList'] && list['childList'].length > 0) {
            // for (let i = 0; i < this.stpDataList.length; i++) {
            //   delete this.stpDataList[i]['file'];
            // }
            for (let i = 0; i < this.stpBooleanDatalist.length; i++) {
              // this.stpBooleanDatalist[i]['serialNo'] = this.selectedCharacter[i];
              delete this.stpBooleanDatalist[i]['file'];
            }
            for (let i = 0; i < this.stpdatavalueformat.length; i++) {
              this.stpdatavalueformat[i]['fileUUID'] = this.fileUUIDList[i];
              this.stpdatavalueformat[i]['serialNo'] = this.selectedCharacter[i];
              delete this.stpdatavalueformat[i]['file'];
            }
            // console.log('1st table',this.stpBooleanDatalist);
            // console.log('2nd table',this.stpdatavalueformat);
            //if (this.indicatorThemes && this.indicatorThemes['value'] == "no") {
              // obj[this.formInputfilter['ay']].push({ "id": list['childList'][0]['entityUUID'], "value": this.indicatorThemes['value'], "childData": this.stpBooleanDatalist }, { "id": list['childList'][1]['entityUUID'], "value": null, "childData": this.stpdatavalueformat }, { "id": list['entityUUID'], "value": list['value'] });
              obj[this.formInputfilter['ay']].push( { "id": list['entityUUID'], "value": list['value'] },{ "id": list['childList'][0]['entityUUID'], "value": this.indicatorThemes['value'], "childData": this.stpBooleanDatalist }, { "id": list['childList'][1]['entityUUID'], "value": null, "childData": this.stpdatavalueformat });
            //}
          }
        }
      })
    });
    //console.log('returnobj',obj);
    return obj;
  }
  stpbisunessData() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploadstpbisunessData());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  uploadstp2Data() {
    let status = this.mandatoryChecksforstpdata();
    if (status == true) {
      let postdata = this.fileList;
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.fileuploadData = data.data;
        if (!isNullOrUndefined(this.fileuploadData)) {
          Object.keys(this.fileuploadData).forEach(key => {
            this.fileUUIDList.push(this.fileuploadData[key]);
          })
        }
        this.stpbisunessData();
      });
    } else {
      this.toastr.error("Fill out the required fields before saving");
    }
  }
  WaterbisunessData() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploadreusageWaterData());
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  uploadWaterData() {
    let status = this.prevalidationChecks();
    if (status == true) {
      // let postdata = this.fileList;
      // this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
      //   this.fileuploadData = data.data;
      //   // console.log('reuse',data);
      //   if (!isNullOrUndefined(this.fileuploadData)) {
      //     Object.keys(this.fileuploadData).forEach(key => {
      //       this.fileUUIDList.push(this.fileuploadData[key]);
      //     })
      //   }
        this.WaterbisunessData();
      // });
    } else {
      this.toastr.error("Fill out the required fields before saving");
    }
  }

  uploadexcel() {
    // console.log('uploadexcel--');
    let dataEnteredFlag;
    this.activeSubIndicators.forEach(element => {
      if(element['value']){
        dataEnteredFlag = true;
      }
    })
      if(dataEnteredFlag){  
      let status = this.validationChecksForValues();
      if(status == true){       
        let postdata;
        postdata = this.selectedFiles;
        // postdata=this.indicatorselectedFile;
        this.submitdataSerivce.uploadFile(postdata).subscribe(data =>{
          if(!isNullOrUndefined(data)){
            let fileuploadData = data.data;
            this.submitData(fileuploadData);
            this.selectedFiles = {};
          }
          this.selectedFiles = {};
        },err =>{
        this.selectedFiles ={};});
      } else{
        this.toastr.error("please enter atleast one indicator data");
      }
      }
      
   
    if(!dataEnteredFlag){
      this.toastr.error("please enter atleast one indicator data"); }
    
  }
  uploadfiledataexcel() {
    let status = this.validationChecksForValues();
    if(status == true){
      let postdata;
    postdata = this.selectedFiles;
    this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
      if (!isNullOrUndefined(data)) {
        this.childsdata = data['data'];
        this.sendpostdata(this.childsdata);
      }
      this.indicatorselectedFile = {};
    }, err => {
      this.indicatorselectedFile = {};
    });
    } else{
      this.toastr.error("please enter atleast one indicator data");
    }
// })
}
  validationChecksForValues(){
    for (let i = 0; i < this.activeSubIndicators.length; i++) {
      if(this.activeSubIndicators[i]['value']){
        if(this.activeSubIndicators[i]['valuechanged'] || this.activeSubIndicators[i]['subindflag']){
          return true
        }

      }
    }
    return false;
  }
  radioValidation(){
    if (isNullOrUndefined(this.indicatorThemes['value']) || this.indicatorThemes['value'] === '') {
      return false;
    } else{
      return true;
    }
  }
  dynamicIndicators(){
    if(this.radioValidation() && this.indicatorThemes['value'] != "null"){
      let postdata;
      postdata = this.indicatorselectedFile;
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {        
        if (!isNullOrUndefined(data)) {
          this.childsdata = data['data'];
          this.formatBackendPost(this.childsdata);
        }
        this.indicatorselectedFile = {};
      }, err => {
        this.indicatorselectedFile = {};
      });
    } else{
        this.toastr.error("please enter the required data");
    }
  }
  uploadplanData(){
    if(this.radioValidation() && this.indicatorThemes['value'] != "null"){
      let postdata;
      postdata = this.indicatorselectedFile;
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        if (!isNullOrUndefined(data)) {
          this.childsdata = data['data'];
          this.formatBackendPost(this.childsdata);
        }
        this.indicatorselectedFile = {};
      }, err => {
        this.indicatorselectedFile = {};
      });
    } else{
        this.toastr.error("please enter the required data");
    }
  }
  formatBackendPost(childsdata) {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploadthemeData(childsdata));
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  sendpostdata(data) {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploadthemedata(data));
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if(data['status']){
        this.toastr.success('Data saved succesfully');
      }  else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else{
        this.toastr.error("Some Exception Occurred")
      }
    });
  }
  uploadthemeData(data) {    
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        // console.log("focc",indicator['foc'])
        let comment;
        if(indicator['label'] == "Whether regular meetings are held with industries (If Yes- No of meetings held and name of industries)" && indicator['value'] == "yes"){
          comment = {
            "nomh" : indicator['nomh'],
            "noi" : indicator['noi']
          }
        } else {
          comment = {"foc" : indicator['foc']};
        }
        if (this.currentId == indicator['entityUUID']) {
          if ((indicator['valuechanged'] || (data && data[indicator['entityUUID']]) || indicator['value'] != null)) {
            if(indicator['foc'] && indicator['foc'] != "" && indicator['foc'] != undefined){
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "serialNo": indicator['sno'],"cmt": comment, "fileUUID": data ? data[indicator['entityUUID']] : null });
            } else if(indicator['label'] == "Whether regular meetings are held with industries (If Yes- No of meetings held and name of industries)" && indicator['value'] == "yes" ){
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "serialNo": indicator['sno'],"cmt": comment, "fileUUID": data ? data[indicator['entityUUID']] : null });
            } else {
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "serialNo": indicator['sno'], "fileUUID": data ? data[indicator['entityUUID']] : null });
            }
          }
        }
      });
    });
    return obj;
  }
  uploadthemedata(fileuploadData) {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          if (indicator['childList'] != null && indicator['childList'].length > 0) {
            this.childList = [];
            this.fileuuid = [];
            indicator['childList'].forEach(subind => {
              if ((subind['valuechanged'] || (fileuploadData && fileuploadData[subind['entityUUID']]))) {
                this.childList.push({ "id": subind['entityUUID'], "value": subind['value'], "serialNo": subind['sno'], "fileUUID": fileuploadData ? fileuploadData[subind['entityUUID']] : null });
              }
            });
            if (this.childList.length > 0) {
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "childData": this.childList })
            }

          } else {
            if (indicator['valuechanged']) {
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "serialNo": indicator['sno'] })
            }
          }
        }
      });
    });
    return obj;
  }
  submitindicatorsData(filedata) {
    this.childList = [];
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray'];
    postdata['data'] = JSON.stringify(this.uploadindicatorsData(filedata));
    postdata['ts'] = new Date().getTime();
    postdata['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = 1;
    postdata['cType'] = "DISTRICT";
    this.submitdataSerivce.submitindicatorsdata(postdata).subscribe(data => {
      if (data.status) {
        this.toastr.success(data.msg);
      }
    });
  }
  
  uploadindicatorsData(filedata) {
    // let index = 0;
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          if (indicator['valuechanged'] || (filedata && filedata[indicator['entityUUID']])) {
            if ((indicator['label'] == "Status and availability of Ganga Praharis, Ganga Mitra/ Volunteer") && indicator['value'] == 'no') {
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "action": indicator['action'], "fileUUID": filedata ? filedata[indicator['entityUUID']] : null })
            } else if (indicator['label'] == "Whether regular meetings are held with industries (If Yes- No of meetings held and name of industries)" && indicator['value'] == 'yes') {
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "action": indicator['meetingreq'], "fileUUID": filedata ? filedata[indicator['entityUUID']] : null });
            } else if (indicator['label'] == "Whether regular meetings are held with industries (If Yes- No of meetings held and name of industries)" && indicator['value'] == 'no') {
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "action": indicator['indusname'], "fileUUID": filedata ? filedata[indicator['entityUUID']] : null })
            } else if (indicator['label'] == "Availability of fecal sludge treatment plants" && indicator['value'] == "yes") {
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "fileUUID": filedata ? filedata[indicator['entityUUID']] : null, "childData": this.planDataList })
            } else {
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "fileUUID": filedata ? filedata[indicator['entityUUID']] : null })
            }
          }
        }
      });
    });
    return obj;
  }
  resetMeetingData(){
    this.selectedDate = null;
    this.dateSelected = false;
    this.showtextBox = false;
    this.selecteditemobj = null;
    this.itemselected = false;
    this.customFilter['cat'] =[];
    this.fileselect=false;
    this.imageselect=false;
    this.imageselect=false;
    this.buttondisable=false;
    this.imagedisable=false;
    this.attendanceFilter['mom'] = "";
    if(this.showtabledata){
      this.tabledataFormat.forEach(element=>{
        if(element['attendance']){
          element['attendance'] = "";
        } 
      })
    } else{
      this.attendanceTableRawData.forEach(element=>{
        if(element['attendance']){
          element['attendance'] = "";
        }
      })
    }
    this.filename = "";
    this.uploadMeetingDataObj['file'] = null;
    this.imagename = "";
    this.imageFiles['photo'] = null;
    this.multiplefileName = "";
    this.multiplefileUpload['file'] = null;
    this.multipleimageName = "";
    this.multipleimgUpload['photo'] = null;
  }

  uploadSubIndicators(fileuploadData) {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          
          if (indicator['childList'] != null && indicator['childList'].length > 0) {
            this.childList = [];
            this.fileuuid = [];
            indicator['childList'].forEach(subind => {
              // console.log("childlistt",subind);
              if(subind['value'] != null){

                if(subind['label'] == "Revenue generation activities on the Ghats" && subind['value'] == "yes"){
                  this.childList.push({ "id": subind['entityUUID'], "value": subind['value'],"wrg": subind['wrg'], "serialNo": subind['sno'], "fileUUID": fileuploadData ? fileuploadData[subind['entityUUID']] : null });              
                } else {
                  let indicatorFileId=fileuploadData?fileuploadData[indicator['entityUUID']]:null;
                // if ((subind['valuechanged'] || (fileuploadData && fileuploadData[subind['entityUUID']]))) {
                  this.childList.push({ "id": subind['entityUUID'], "value": subind['value'], "serialNo": subind['sno'],"nomh": subind['nomh'], "fileUUID": fileuploadData ? fileuploadData[subind['entityUUID']] : null });    
                  // this.childList.push({ "id": subind['entityUUID'], "value": subind['value'], "serialNo": subind['sno'], "fileUUID": indicatorFileId ? indicatorFileId : fileuploadData[subind['entityUUID']]  });             
                // }
                }
              }
            });
            if (this.childList.length > 0) {
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": this.childList ,"fileUUID":fileuploadData ? fileuploadData[indicator['entityUUID']]:null });
            }

          } else {
            if (indicator['valuechanged']) {
              obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "serialNo": indicator['sno'] })
            }
          }
        }
      });
    });
    return obj;
  }
  uploadBisunessData() {
    // let index = 0;
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          for (let i = 0; i < this.subIndicatorList.length; i++) {
            this.subIndicatorList[i]['fileUUID'] = this.fileUUIDList[i];
            this.subIndicatorList[i]['serialNo'] = this.selectedCharacter[i];
          }
          for (let i = 0; i < this.subIndicatorList.length; i++) {
            delete this.subIndicatorList[i]['file'];
            delete this.subIndicatorList[i]['fileName'];
          }
          let childList = this.subIndicatorList;
          // index++;
          // if (indicator['valuechanged']) {
          obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childList })
          // }
        }
      });
    });
    return obj;
  }
  uploadRiversData() {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          for (let i = 0; i < this.smallRiverList.length; i++) {
            this.smallRiverList[i]['fileUUID'] = this.fileUUIDList[i];
            this.smallRiverList[i]['serialNo'] = this.selectedCharacter[i];
          }
          for (let i = 0; i < this.smallRiverList.length; i++) {
            delete this.smallRiverList[i]['file'];
            delete this.smallRiverList[i]['fileName'];
          }
          let childList = this.smallRiverList
          // if (indicator['valuechanged']) {
          obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childList })
          // }
        }
      });
    });
    return obj;
  }
  uploadindustryData() {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          for (let i = 0; i < this.grossDataList.length; i++) {
            this.industryDataList[i]['fileUUID'] = this.fileUUIDList[i];
            this.industryDataList[i]['serialNo'] = this.selectedCharacter[i];
          }
          for (let i = 0; i < this.grossDataList.length; i++) {
            delete this.industryDataList[i]['file'];
            delete this.industryDataList[i]['fileName'];
          }
          let childList = this.industryDataList
          // if (indicator['valuechanged']) {
          obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childList })
          // }
        }
      });
    });
    return obj;
  }
  uploadWetLandData() {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          for (let i = 0; i < this.wetLandList.length; i++) {
            this.wetLandList[i]['fileUUID'] = this.fileUUIDList[i];
            this.wetLandList[i]['serialNo'] = this.selectedCharacter[i];
          }
          for (let i = 0; i < this.wetLandList.length; i++) {
            delete this.wetLandList[i]['file'];
            delete this.wetLandList[i]['fileName'];
          }
          let childList = this.wetLandList;
          // if (indicator['valuechanged']) {
          obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childList })
          // }
        }
      });
    });
    return obj;
  }
  uploadbisunessData() {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          for (let i = 0; i < this.springBisunessDataList.length; i++) {
            this.springBisunessDataList[i]['fileUUID'] = this.fileUUIDList[i];
            this.springBisunessDataList[i]['serialNo'] = this.selectedCharacter[i];
          }
          for (let i = 0; i < this.springBisunessDataList.length; i++) {
            delete this.springBisunessDataList[i]['file'];
            delete this.springBisunessDataList[i]['fileName'];
          }
          let childList = this.springBisunessDataList;
          // if (indicator['valuechanged']) {
          obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childList })
          // }
        }
      });
    });
    return obj;
  }
  uplaodgrosBisunessData() {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          for (let i = 0; i < this.grossDataList.length; i++) {
            this.grossDataList[i]['fileUUID'] = this.fileUUIDList[i];
            this.grossDataList[i]['serialNo'] = this.selectedCharacter[i];
          }
          for (let i = 0; i < this.grossDataList.length; i++) {
            delete this.grossDataList[i]['file']
          }
          let childList = this.grossDataList;
          // if (indicator['valuechanged']) {
          obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childList })
          // }
        }
      });
    });
    return obj;
  }
  uplaodnallaBisunessData() {    
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          for (let i = 0; i < this.nallaDataList.length; i++) {
            this.nallaDataList[i]['fileUUID'] = this.fileUUIDList[i];
            this.nallaDataList[i]['serialNo'] = this.selectedCharacter[i];
          }
          for (let i = 0; i < this.nallaDataList.length; i++) {
            delete this.nallaDataList[i]['file']
          }
          let childList = this.nallaDataList;
          // if (indicator['valuechanged']) {
          obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childList })
          // }
        }
      });
    });
    return obj;
  }
  // uplaodStpBisunessData(){
  //   let obj = {
  //     [this.formInputfilter['ay']]: []
  //   }
  //   this.fetchData.forEach(element => {
  //     element['childList'].forEach(indicator => {
  //       if (this.currentId == indicator['entityUUID']) {
  //         for(let i=0;i<this.stpDataList.length;i++){
  //           this.stpDataList[i]['fileUUID'] = this.fileUUIDList[i];
  //           this.stpDataList[i]['serialNo'] = this.selectedCharacter[i];
  //         }
  //         for(let i=0;i<this.stpBooleanDataList.length;i++){
  //           this.stpBooleanDataList[i]['fileUUID'] = this.fileUUIDList[i];
  //           this.stpBooleanDataList[i]['serialNo'] = this.selectedCharacter[i];
  //         }
  //         let childList = this.stpDataList;
  //         let childlist = this.stpBooleanDataList;
  //         if(indicator['valuechanged']) {
  //           obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childList });
  //         }
  //         // } else if(indicator['valuechanged'] && this.stpboolean){
  //         //   obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childlist });
  //         // }
  //         // } else{
  //         //   obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value']})
  //         // }
  //       }
  //     });
  //   });
  //   return obj;
  // }
  uplaodStpBisunessData() {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(list => {
        if (this.currentId == list['entityUUID']) {
          if (list['childList'] && list['childList'].length > 0) {
            for (let i = 0; i < this.stpDataList.length; i++) {
              this.stpDataList[i]['fileUUID'] = this.fileUUIDList[i];
              this.stpDataList[i]['serialNo'] = this.selectedCharacter[i];
            }
            for (let i = 0; i < this.stpBooleanDataList.length; i++) {
              this.stpBooleanDataList[i]['fileUUID'] = this.fileUUIDList[i];
              this.stpBooleanDataList[i]['serialNo'] = this.selectedCharacter[i];
            }
            if (this.indicatorThemes && this.indicatorThemes['value'] == "yes") {
              obj[this.formInputfilter['ay']].push({ "id": list['childList'][0]['entityUUID'], "value": null, "childData": this.stpBooleanDataList }, { "id": list['entityUUID'], "value": list['value'] });
            }
            // } else if (this.indicatorThemes && this.indicatorThemes['value'] == "no") {
            //   obj[this.formInputfilter['ay']].push({ "id": list['childList'][0]['entityUUID'], "value": null, "childData": this.stpDataList }, { "id": list['childList'][1]['entityUUID'], "value": null, "childData": this.stpBooleanDataList }, { "id": list['entityUUID'], "value": list['value'] })
            // }
          }
        }
      });
    });
    return obj;
  }
  allowingValuesinput(event, row) {
    if (row['label'] == "ULB Name") {
      let inp = String.fromCharCode(event.keyCode);

      if (/[a-zA-Z0-9]/.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    } else {
      let charCode = (event.which) ? event.which : event.keyCode;
      if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      return true;
    }
  }
  uploadstpbisunessData() {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          for (let i = 0; i < this.stpPercentageDataList.length; i++) {
            this.stpPercentageDataList[i]['fileUUID'] = this.fileUUIDList[i];
            this.stpPercentageDataList[i]['serialNo'] = this.selectedCharacter[i];
          }
          for (let i = 0; i < this.stpPercentageDataList.length; i++) {
            delete this.stpPercentageDataList[i]['file']
          }
          let childList = this.stpPercentageDataList;
          // if (indicator['valuechanged']) {
          obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childList })
          // }
        }
      });
    });
    return obj;
  }
  uploadreusageWaterData() {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (this.currentId == indicator['entityUUID']) {
          for (let i = 0; i < this.waterReusedDataList.length; i++) {
            // this.waterReusedDataList[i]['fileUUID'] = this.fileUUIDList[i];
            this.waterReusedDataList[i]['serialNo'] = this.selectedCharacter[i];
          }
          for (let i = 0; i < this.waterReusedDataList.length; i++) {
            delete this.waterReusedDataList[i]['file']
          }
          let childList = this.waterReusedDataList;
          // if (indicator['valuechanged']) {
          obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'], "childData": childList })
          // }
        }
      });
    });
    return obj;
  }
  checkIndicatorValues() {
    let obj = {
      [this.formInputfilter['ay']]: []
    }
    this.fetchData.forEach(element => {
      element['childList'].forEach(indicator => {
        if (indicator['valuechanged']) {
          obj[this.formInputfilter['ay']].push({ "id": indicator['entityUUID'], "value": indicator['value'] })

        }
      })
    });
    return obj;
  }

  uploadingdataformat(fileuploadData) {
    let obj = {
      [this.currentyr]: [],
      [this.prevyr]: []
    }
    this.heirarchydata.forEach(element => {
      element['childList'].forEach(list => {
        if ((list['year'] == this.currentyr) && list['childList'] && list['childList'].length > 0) {
          if (list['childList'][0]['valuechanged'] || list['childList'][1]['valuechanged'] || (fileuploadData && fileuploadData[list['entityUUID']])) {
            if (list['childList'][0]['updatedValue'] != null) {
              obj[this.currentyr].push({
                "id": list['entityUUID'], "value": list['value'], "numerator": list['childList'][0]['updatedValue'],
                "denominator": list['childList'][1]['updatedValue'], 'fileUUID': fileuploadData ? fileuploadData[list['entityUUID']] : null
              })
            } else {
              obj[this.currentyr].push({
                "id": list['entityUUID'], "value": list['value'], "numerator": list['childList'][0]['value'],
                "denominator": list['childList'][1]['value'], 'fileUUID': fileuploadData ? fileuploadData[list['entityUUID']] : null
              })
            }
          }
        } else if ((list['year'] == this.currentyr) && !list['childList'] && (list['valuechanged'] || (fileuploadData && fileuploadData[list['entityUUID']]))) {
          obj[this.currentyr].push({ "id": list['entityUUID'], "value": list['value'], 'fileUUID': fileuploadData ? fileuploadData[list['entityUUID']] : null })
        } else if ((list['year'] == this.prevyr) && (list['valuechanged'] || (fileuploadData && fileuploadData[list['entityUUID']]))) {
          obj[this.prevyr].push({ "id": list['entityUUID'], "value": list['value'], 'fileUUID': fileuploadData ? fileuploadData[list['entityUUID']] : null })
        }
      });

    });
    return obj;
  }
  getbasicparams() {
    let postdata = {};
    postdata['ay'] = this.formInputfilter['ay'];
    postdata['subTp'] = this.formInputfilter['montharray']
    postdata['lu'] = this.districtflag ? this.formInputfilter['distuuid'] : this.formInputfilter['lu']
    postdata['userId'] = this.userdetails['loggedUserData']['userProfile']['userId'];
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['component'] = this.constants.COMPONENT['ACTUAL_DATA'];
    postdata["cType"] = (this.districtflag || this.userlocationtype == 'DISTRICT') ? this.constants.LOCATION_CONSTANT['DISTRICT'] : this.constants.LOCATION_CONSTANT['STATE']
    return postdata;
  }
  nonDynamicReset(){
    if((this.indicatorThemes['value']!=null) || this.indicatorThemes['valuechanged']){
      if(this.indicatorThemes['label'] == 'Regular cleaning of Ghats is happening / Frequency' && this.indicatorThemes['value'] == 'yes'){
        this.indicatorThemes['foc'] = "";
      } else if(this.indicatorThemes['label'] == 'Status and availability of Ganga Praharis, Ganga Mitra/ Volunteer' && this.indicatorThemes['value'] == 'no'){
        this.indicatorThemes['action'] = "";
      }
      // this.indicatorThemes['fileupload'] = true
      // this.indicatorselectedFile[id] = event.target.files[0];


      this.indicatorThemes['value'] = null;
      this.indicatorThemes['fileupload'] = false;
      this.indicatorThemes['selectedFile'] = "";
      this.fileId = "";
      this.indicatorThemes['valuechanged'] = false;
      this.indicatorThemes['fileUUID']=null;
      this.indicatorThemes['fileName']=null;
      this.indicatorThemes['foc'] = "";
      this.indicatorThemes['nomh'] = "";
      this.indicatorThemes['noi'] = "";
      this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully');
    } else {
      this.toastr.error("Please Enter Data Before Reset");
    }
  } 
   resetData(){
    let resetindicator,resetsubindicator =false;
    let valuePresent = false;
    if ((this.indicatorThemes['value']!=null) || this.indicatorThemes['selectedFile']){

      this.indicatorThemes['value']=null;
      this.indicatorThemes['fileUUID']=null;
      this.indicatorThemes['fileName']=null;
      resetindicator=true;

      if (this.indicatorThemes['selectedFile'])
      {
        this.indicatorThemes['selectedFile']=null;
        this.fileId='';
        this.indicatorThemes['fileupload'] = false;
        this.indicatorThemes['valuechanged']=false;
      }
      this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
    }
    for(let i=0;i<this.activeSubIndicators.length;i++){
      if(this.activeSubIndicators[i]['value'] || this.activeSubIndicators[i]['valuechanged']){
        valuePresent = true
      }
    }
    //valuePresent=true;
    if(valuePresent){
     for(let i=0;i<this.activeSubIndicators.length;i++){
      // console.log("reset",this.activeSubIndicators[i]);
      this.activeSubIndicators[i]['fileUUID']=null;
      this.activeSubIndicators[i]['fileName']=null;
      if(this.activeSubIndicators[i]['valuechanged'] || this.activeSubIndicators[i]['fileSelected']){
        this.activeSubIndicators[i]['value'] = null;
        this.activeSubIndicators[i]['wrg'] = null;
        this.activeSubIndicators[i]['fileSelected'] = false
        this.activeSubIndicators[i]['isFileSelect'] = "";
        this.activeSubIndicators[i]['fileId'] = "";
        this.exceluploadData['excelFile'] = null;
        this.activeSubIndicators[i]['excelFile'] = null;
        this.activeSubIndicators[i]['valuechanged'] = false;
        this.activeSubIndicators[i]['nomh'] = "";
        valuePresent=false;
        resetsubindicator=true;
        this.toastr.success(this.activeSubIndicators[i]['sno'] + ' Values Reset Successfully');
       } else if(this.activeSubIndicators[i]['subindflag']){
        this.activeSubIndicators[i]['value'] = null;
       }     
    }
   } 
   if (resetindicator || resetsubindicator){
    
   }
   else {
    this.toastr.error("Please Enter Data Before Reset")
   }

  }
  dynamicReset(){
    if(this.indicatorThemes['label'] == "Number of Nalla's in the district flowing into tributaries or Ganga directly"){
      this.valuePresent=false;
      this.subIndicatorList.forEach(obj => {
        if (obj['fd'] || obj['nln'] || obj['rtfall'] || obj['sin'] || obj['fileUUID'] || obj['serialNo']){
          this.valuePresent=true;
        }
      })
      this.subIndicatorList.forEach(obj => {
        if(obj['valuechanged'] || this.valuePresent){
          obj['fd'] = null;
          obj['nln'] = null;
          obj['rtfall'] = null;
          obj['sin'] = null;
          obj['isFileSelect'] = "";
          obj['fileId']="";
          obj['fileselected']=false;
          obj['valuechanged']=false;
          obj['fileUUID']=null;
          obj['fileName']=null;
          this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
        } else{
          this.toastr.error("Please Enter Data Before Reset")
        }
      });
    } else if(this.indicatorThemes['label'] == "Small River rejuvenation"){
      this.smallRiverList.forEach(obj => {
        this.valuePresent=false;
        if (obj['srn'] || obj['nactrjv'] || obj['ptrp'] || obj['rau'] || obj['losrr'] || obj['isFileSelect'] || obj['fileUUID']){
          this.valuePresent=true;
        }
        if(obj['valuechanged'] || this.valuePresent){
          obj['srn'] = null;
          obj['nactrjv'] = null;
          obj['ptrp'] = null;
          obj['rau'] = null;
          obj['losrr'] = null;

          obj['isFileSelect'] = "";
          obj['fileId']="";
          obj['fileselected']=false;
          obj['valuechanged']=false;
          obj['fileUUID']=null;
          obj['fileName']=null;
          this.exceluploadData['excelFile']=null;
          this.selectedFile="";
          this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
        } else{
          this.toastr.error("Please Enter Data Before Reset")
        }
      })
    } else if(this.indicatorThemes['label'] == "Wetland conservation"){
      this.wetLandList.forEach(obj => {
        this.valuePresent=false;
        if(obj['wlnl'] || obj['wlsz'] || obj['atfwlc'] || obj['fileUUID'] || obj['fileUUID'] || obj['isFileSelect']){
          this.valuePresent=true;
        }
        if(obj['valuechanged'] || this.valuePresent){
          obj['wlnl'] = null;
          obj['wlsz'] = null;
          obj['atfwlc'] = null;

          obj['isFileSelect'] = "";
          obj['fileId']="";
          obj['fileselected']=false;
          obj['valuechanged']=false;
          obj['fileUUID']=null;
          obj['fileName']=null;
          this.exceluploadData['excelFile']=null;
          this.selectedFile="";
          this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
        } else{
          this.toastr.error("Please Enter Data Before Reset")
        }
      })
    } else if(this.indicatorThemes['label'] == "Spring Rejuvenation"){
      this.valuePresent=false;
      this.springBisunessDataList.forEach(obj => {
        if (obj['sprn'] || obj['atfrs'] || obj['scors'] || obj['isFileSelect'] || obj['fileUUID']){
          this.valuePresent=true;
        }
        if(obj['valuechanged'] || this.valuePresent){
          obj['sprn'] = null;
          obj['atfrs'] = null;
          obj['scors'] = null;

          obj['isFileSelect'] = "";
          obj['fileId']="";
          obj['fileselected']=false;
          obj['valuechanged']=false;
          obj['fileUUID']=null;
          obj['fileName']=null;
          this.exceluploadData['excelFile']=null;
          this.selectedFile="";
          this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
        } else{
          this.toastr.error("Please Enter Data Before Reset")
        }
    })
    } else if(this.indicatorThemes['label'] == "List of Gross Polluting Industries (GPI)"){
      this.valuePresent=false;
      this.grossDataList.forEach(obj => {
        if (obj['indn'] || obj['sect'] || obj['etpp'] || obj['dcw']){
          this.valuePresent=true;
        }
        })
      this.grossDataList.forEach(obj => {
        if(obj['valuechanged'] || this.valuePresent){
          obj['indn'] = null;
          obj['sect'] = null;
          obj['etpp'] = null;
          obj['dcw'] = null;
          obj['valuechanged']=false;
          this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
        } else{
          this.toastr.error("Please Enter Data Before Reset")
        }
    })
    } else if(this.indicatorThemes['label'] == "Action taken against non-compliant Industries"){
      this.valuePresent=false;
      this.industryDataList.forEach(obj => {
        if (obj['indn'] || obj['nact'] || obj['epani'] || obj['ihbc'] || obj['indclsr'] || obj['isFileSelect']){
          this.valuePresent=true;
        }
        if(obj['valuechanged'] || this.valuePresent){
          obj['indn'] = null;
          obj['nact'] = null;
          obj['epani'] = null;
          obj['ihbc'] = null;
          obj['indclsr'] = null;
          obj['isFileSelect'] = "";

          obj['fileId']="";
          obj['fileselected']=false;
          obj['valuechanged']=false;
          obj['fileUUID']=null;
          obj['fileName']=null;
          this.exceluploadData['excelFile']=null;
          this.selectedFile="";
          this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
        } else{
          this.toastr.error("Please Enter Data Before Reset")
        }
      })
     } else if(this.indicatorThemes['label'] == "Tapping of Nalla's"){
      this.valuePresent=false;
      this.nallaDataList.forEach(obj => {
        if (obj['nln'] || obj['td'] || obj['cubrn']){
          this.valuePresent=true;
        }
      })
      this.nallaDataList.forEach(obj => {
        if(obj['valuechanged'] || this.valuePresent){
          obj['nln'] = null;
          obj['td'] = null;
          obj['cubrn'] = null;
          obj['valuechanged']=false;
          this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
        } else{
          this.toastr.error("Please Enter Data Before Reset")
        }
      })
     } else if(this.indicatorThemes['label'] == "Percentage of work completed for new STPs under construction"){
      this.valuePresent=false;
      this.stpPercentageDataList.forEach(obj => {
        if (obj['stpn'] || obj['flfc']  || obj['asic'] || obj['fileUUID'] || obj['serialNo']){
          this.valuePresent=true;
        }
      })
      this.stpPercentageDataList.forEach(obj => {
        if(obj['valuechanged'] || this.valuePresent){
          obj['stpn'] = null;
          obj['flfc'] = null;
          obj['asic'] = null;
          obj['valuechanged']=false;
          this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
        } else{
          this.toastr.error("Please Enter Data Before Reset")
        }
     })
     } else if(this.indicatorThemes['label'] == "Reuse of treated waste water for different purposes mentioned below"){
      let resetindicator,resetsubindicator=false;
      this.valuePresent=false;
      if (this.indicatorThemes['value']=='yes' || this.indicatorThemes['value']=='no'){
        //console.log('indicatorThemes[value]',this.indicatorThemes['vlaue']);
        this.indicatorThemes['value']=null;
        this.indicatorThemes['valuechanged']=false;
        resetindicator=true;
        this.toastr.success(this.indicatorThemes['sno']+'Values Reset Successfully');
      }
      this.waterReusedDataList.forEach(obj =>{
        if (obj['stpn'] || obj['custpc'] || obj['tr'] || obj['cmrcl'] || obj['cnsrn'] || obj['agcl'] || obj['grdng'] || obj['onp'] ){
          this.valuePresent=true;
        }
      })
      this.waterReusedDataList.forEach(obj => {
        if(obj['valuechanged'] || this.valuePresent){
          obj['stpn'] = null;
          obj['custpc'] = null;
          obj['tr'] = null;
          obj['cmrcl'] = null;
          obj['cnsrn'] = null;
          obj['agcl'] = null;
          obj['grdng'] = null;
          obj['onp'] = null;
          obj['valuechanged']=false;
          resetsubindicator=true;
          this.toastr.success(this.indicatorThemes['sno'] + 'a Values Reset Successfully')
        } 
        if (!(resetindicator || resetsubindicator)){
          this.toastr.error("Please Enter Data Before Reset")
        }
        // else{
        //   this.toastr.error("Please Enter Data Before Reset")
        // }
      })
     } else if(this.indicatorThemes['label'] == "Are all STPs in the district operational" && this.indicatorThemes['value'] == 'yes' ){ // && this.indicatorThemes['value'] == "yes"
      this.valuePresent=false;
      let indicatorreset=false;
      let resetdone=false;   
      this.stpdataformat.forEach(obj => {
        if (obj['stpn']||obj['stpc']||obj['custpc']||obj['mds']||obj['dcgmc']||obj['pcstpu']||obj['fileUUID']){
          this.valuePresent=true;
        }
      })   
      this.stpdataformat.forEach(obj => {
        //console.log("reset",obj);
        if(obj['valuechanged'] || this.valuePresent){
          obj['stpn'] = null;
          obj['stpc'] = null;
          obj['custpc'] = null;
          obj['mds'] = null;
          obj['dcgmc'] = null;
          obj['pcstpu'] = null;
          obj['isFileSelect'] = "";
          obj['valuechanged']=false;
          obj['fileId']="";
          obj['fileselected']=false;
          obj['fileUUID']=null;
          obj['fileName']=null;
          // this.indicatorThemes['value']=null;
          // this.indicatorThemes['valuechanged']=false;
          // this.stpDatavalue = null;
          // this.stpDatavalue2 = null;
          // this.stpboolean=null;
          this.exceluploadData['excelFile']=null;
          resetdone=true;
          this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
        } 
        if(this.indicatorThemes['value']=='yes'){
          this.indicatorThemes['value']=null;
          this.indicatorThemes['valuechanged']=false;
          this.stpDatavalue = null;
          this.stpDatavalue2 = null;
          this.stpboolean=null;
          indicatorreset=true;
          this.toastr.success(this.indicatorThemes['sno'] + 'Values Reset Successfully');
          
        }
        if (indicatorreset || resetdone){
          //this.toastr.success(this.indicatorThemes['sno'] + 'Values Reset Successfully');
        }
        else{
          //console.log('theme',this.indicatorThemes,'stpdata',this.stpData,'stpdataval',this.stpDatavalue,'end');
          this.toastr.error("Please Enter Data Before Reset")
        }
      })
      } else if(this.indicatorThemes['label'] == "Are all STPs in the district operational" && (this.stpboolean || this.stpDatavalue2)){
      this.valuePresent =false;
      let resetdone=false;
      let indicatorreset=false;
      if (this.indicatorThemes['value']=="no"){
        this.indicatorThemes['value']=null;
        this.indicatorThemes['valuechanged']=false;
        this.stpDatavalue = null;
        this.stpDatavalue2 = null;
        this.stpboolean=null;
        indicatorreset=true;
        this.toastr.success(this.indicatorThemes['sno']+'Values Reset Successfully');
      }
      //this.stpyesdatalist.forEach(item=>{)
      this.stpBooleanDataList.forEach( item => {
        if (item['stpn']||item['nact']||item['pa']||item['uom']||item['urn']||item['ut']||item['dprp']||item['fileUUID']){
          this.valuePresent=true;
        }
      })
      this.stpBooleanDatalist.forEach(item=>{
        if(item['valuechanged'] || this.valuePresent){
          item['stpn'] = null;
          item['nact'] = null;
          item['dprp'] = null;
          item['pa'] = null;
          item['uom'] = null;
          item['urn'] = null;
          item['ut'] = null;
          item['isFileSelect'] = "";
          item['valuechanged']=false;
          item['fileUUID']=null;
          item['fileName']=null;
          this.toastr.success(this.indicatorThemes['sno'] + 'Sewerage Treatment Plants (STPs) - Non Functional Values Reset Successfully');
          resetdone=true;
         } //else{
        //   this.toastr.error("Please Enter Data Before Reset")
        // }
        // this.toastr.success(this.indicatorThemes['sno'] + 'Sewerage Treatment Plants (STPs) - Non Functional Values Reset Successfully');
        this.stpdatavalueformat.forEach(item => {
          if (item['stpn:']||item['stpc']||item['custpc']||item['mds']||item['dcgmc']||item['pcstpu']||item['fileUUID']){
            this.valuePresent=true;
          }
        })
        this.stpdatavalueformat.forEach(item=>{
          if(item['valuechanged'] || this.valuePresent){
          item['stpn'] = null;
          item['dcgmc'] = null;
          item['custpc'] = null;
          item['mds'] = null;
          item['pcstpu'] = null;
          item['stpc'] = null;
          item['isFileSelect'] = "";
          item['valuechanged']=false;
          item['fileselected'] = false;
          item['fileId']="";
          item['fileUUID']=null;
          item['fileName']=null;
          this.exceluploadData['excelFile']=null;
          resetdone=true;
          this.toastr.success(this.indicatorThemes['sno'] + 'Sewerage Treatment Plants (STPs) -Functional Values Reset Successfully')
          }// else{
          //   this.toastr.error("Please Enter Data Before Reset")
          // }
        });
      })
      if (resetdone || indicatorreset){
        //this.toastr.success('Values Reset Successfully');
      }
      else{
        this.toastr.error("Please Enter Data Before Reset")
      }
    } else if(this.indicatorThemes['label'] == "Number of meetings held of DGC"){
      //this.nonDynamicReset();
      // if(this.indicatorThemes['valuechanged']){
      //   this.indicatorThemes['value'] = null;
      //   this.indicatorThemes['valuechanged'] = false;
      //   this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully');
      // } else {
      //   this.toastr.error("Please Enter Data Before Reset")
      // }
      this.resetData();
    } 
  }

  planlabelReset(){
    if(this.indicatorThemes['valuechanged'] || this.indicatorThemes['value']!=null){
      this.planDataList.forEach(obj => {
        if(obj['valuechanged']){
          obj['stpn'] = null;
          obj['stpc'] = null;
         }
      })
      this.indicatorThemes['value'] = null;
      this.indicatorThemes['fileupload'] = false;
      this.indicatorThemes['selectedFile'] = "";
      this.fileId = "";
      this.indicatorThemes['valuechanged'] = false;
      this.indicatorThemes['fileUUID']=null;
      this.indicatorThemes['fileName']=null;
      this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
    } else{
      this.toastr.error("Please Enter Data Before Reset")
    }
  }

  indicatorResetData() {
    // this.activeSubIndicators['value']
    
    this.activeSubIndicators.forEach(element =>{
      // console.log("element",element['value'],element.value);
      if(element['value']){
          element['valuechanged'] = true}
        

        if(element['valuechanged'] || element['fileSelected']){
          element['value'] = null;
          element['fileSelected'] = false;
          element['fileId'] = "";
          element['isFileSelect'] = "";
          this.exceluploadData['excelFile'] = null;
          element['excelFile'] = null;
          element['valuechanged'] = false;
          element['fileUUID']=null;
          element['fileName']=null;
          this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
        }
      else {
        this.toastr.error("Please Enter Data Before Reset")
      }
    })
    
    //   if (this.indicatorThemes) {
    //   if (this.indicatorThemes['valuechanged'] || this.indicatorThemes['fileupload']) {
    //     this.indicatorThemes['value'] = null;
    //      this.indicatorThemes['fileupload'] = false;
    //      this.indicatorThemes['selectedFile'] = "";
    //      this.fileId = ""

    //   }
    // }
  }


  radioReset(){
    if(this.indicatorThemes['valuechanged'] || this.indicatorThemes['value']!=null){
      this.indicatorThemes['value'] = null;
      this.indicatorThemes['fileupload'] = false;
      this.indicatorThemes['selectedFile'] = "";
      this.fileId = "";
      this.indicatorThemes['valuechanged'] = false;
      this.toastr.success(this.indicatorThemes['sno'] + ' Values Reset Successfully')
    } else{
      this.toastr.error("Please Enter Data Before Reset")
    }
  }
  radioNull(){
      this.toastr.error("Please Enter Data")
  }
  typechanged() {
    if (this.formInputfilter['datasubmit'] == 'statewise') {
      this.districtflag = false;
    } else {
      this.districtflag = true;
    }
  }
  validateValues() {

  }
  yearchanged(fieldValue) {
    this.disableedit = this.submitdataSerivce.checkwindow(this.windowdata, fieldValue, this.formInputfilter['lu'])
  }
  checkvalue(value) {
    if (value)
      return value;
    return '-';
  }
  checkNumden(numval) {
    if (numval) {
      return numval;
    } else {
      return '-'
    }

  }
  dynamicIndicatorsValueChanged(row){
  if(row['td'] == 'yes'){
    row['cubrn'] = null;
  }
  row['valuechanged'] = true;
  }

  public Basicvalidation(): boolean {
    this.Validation[0] = this.utils.checkfield(this.selectedFiles);

    return this.Validation[0];
  }
  cDivided(x, y) {
    return (x / y * 100).toFixed(2);
  }
  public basicvalidation(): boolean {
    this.validation[0] = this.utils.checkfield(this.formInputfilter['ay'])
    this.validation[1] = this.utils.checkfield(this.formInputfilter['montharray'])
    return this.validation[0] && this.validation[1];
  }
  mandatoryCheck() {
    if (this.utils.checkfield(this.formInputfilter['ay'])) {
      this.validation['year'] = true;
    } else {
      this.validation['year'] = false;
    }

    if (this.utils.checkfield(this.formInputfilter['montharray'])) {
      this.validation['month'] = true;
    } else {
      this.validation['month'] = false;
    }
    return this.validation['year'] && this.validation['month'];
  }
  fileValidation() {
    this.wrongFileCheck = false;
    let fileInput = document.getElementById('meeting_pics');
    let filePath = fileInput['value'];
    let allowedExtensions = /(\.pdf)$/i;
    if (!allowedExtensions.exec(filePath)) {
      this.wrongFileCheck = true;
      this.toastr.error(('Please upload file having extensions .pdf only.'));
      fileInput['value'] = '';
      return false;
    } else {
      this.toastr.success(('Correct File Selected'));
      return true;
    }
  }
  imageValidation() {
    this.wrongimgflag = false;
    let allowedExtensions = ['jpeg', 'jpg', 'png'];
    let fileExtension = document.getElementById('image_pics')['value'].split('.').pop().toLowerCase();
    let isValidFile = false;
    let imageuploaded = document.getElementById('image_pics')['value']['size'];

    for (var index in allowedExtensions) {
      if (fileExtension == allowedExtensions[index]) {
        isValidFile = true;
        break;
      }
    }
    if (!isValidFile) {
      this.wrongimgflag = true;
      this.toastr.error('Allowed Extensions are : *.' + allowedExtensions.join(', *.'));
      
    } else if (this.imageFiles['photo']['size'] > 5000000){
      this.wrongimgflag = true;
      this.imagename = "";
      this.toastr.error("Image size is more than 5 MB")
    } else {
      this.toastr.success(('Correct Image Selected'));
    }

    return isValidFile;


  }
  multiplefileValidation() {
    this.wrongFileCheck = false;
    let fileInput = document.getElementById('meeting_pics1');
    let filePath = fileInput['value'];
    let allowedExtensions = /(\.docx|\.xlsx|\.pdf|\.ppt |\.xls|\.pptx)$/i;
    if (!allowedExtensions.exec(filePath)) {
      this.wrongFileCheck = true;
      this.toastr.error(('Please upload file having extensions .docx/.xlsx/.pdf/.ppt/.pptx only.'));
      fileInput['value'] = '';
      return false;
    } else {
      this.toastr.success(('Correct File Selected'));
      return true;
    }
  }
  imagemutilpleValidations() {
    this.wrongimgflag = false;
    let allowedExtensions = ['jpeg', 'jpg', 'png'];
    let fileExtension = document.getElementById('image_pics1')['value'].split('.').pop().toLowerCase();
    let isValidFile = false;
    for (var index in allowedExtensions) {
      if (fileExtension == allowedExtensions[index]) {
        isValidFile = true;
        break;
      }
    }
    if (!isValidFile) {
      this.wrongimgflag = true;
      this.toastr.error('Allowed Extensions are : *.' + allowedExtensions.join(', *.'));
    } else
    this.toastr.success(('Correct Image Selected'));

    return isValidFile;
  }
  validateEmail(email) {
    let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    //var address = document.getElementById[email].value;
    if (reg.test(email) == false) {
      this.toastr.error("Please Enter Valid Email");
      this.emailvalid = false;
      return false;
    } else {
      this.emailvalid = true;
      return true;
    }
  }
  removeMinutesFile() {
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.filename = "";
        this.fileselect=false;
        this.uploadMeetingDataObj['file'] = null;
        this.buttondisable=false;

      }
    })
  }
  removeMinutesPhoto(){
    this.modalRef = this.modalService.open(RemoveRecordPopupComponent, { backdrop: 'static', windowClass: 'backgroundTransparent  my-class' });
    this.modalRef.componentInstance.title = 'Do you want to remove this record ?';
    this.modalRef.componentInstance.onDelete.subscribe((receivedEntry) => {
      if (receivedEntry === true) {
        this.imagename = "";
        this.imageselect=false;
        this.imageFiles['photo'] = null;
        this.imagedisable=false;

      }
    })
  }
  validateContact(contact){
    // console.log(contact,contact.length);
    let mobile = contact;
  //  console.log(mobile);
   
    if(contact.length<9){
       this.toastr.error("number must be 10 characters");
    }else {
      this.toastr.success("Contact no. is 10 digits")
    }
  
  }
  mandatoryFieldCheck(tabledata){
    tabledata['filled'] = true;
  }
  
  checkAllFieldsChanged(tabledata,i){
    if(tabledata['officials'][i]){

      tabledata['valuchanged'] = true
    }
  }

  checkThemeName(label){
   return Object.keys(themedataObj).includes(label);
  //  this.themeList.includes(label);
  }

  checkIndicator(label){
   return Object.keys(indicatorlist).includes(label);
  }

  checkSubIndicator(label){
    return Object.keys(subindlist).includes(label);
  }
  Message(value){
    if (!value){
      // this.toastr.error("Please fill all the required details in Meeting at DGC section");
      this.modalReference = this.modalService.open(this.alertModal,{windowClass:'submit-modal-centered'});
      this.modalReference.result.then((result) => {
      }, (reason) => {
      });
    }
  }
  CloseWindowModal(){
    this.modalReference.dismiss();
  }

}
function radioReset() {
  throw new Error('Function not implemented.');
}

